(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (document.querySelector('.rf-tcv')) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
        return;
      }
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-home-v2-offers-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-rfv2-promo]').forEach((section) => {
      if (section.dataset.rfv2PromoReady) return;
      const rail = section.querySelector('[data-rfv2-promo-rail]');
      const slides = Array.from(section.querySelectorAll('[data-rfv2-promo-slide]'));
      if (!rail || slides.length < 2) return;
      section.dataset.rfv2PromoReady = 'true';
      const nav = section.querySelector('[data-rfv2-promo-nav]');
      const arrows = section.querySelector('[data-rfv2-promo-arrows]');
      const dots = Array.from(section.querySelectorAll('[data-rfv2-promo-dot]'));
      const toggle = section.querySelector('[data-rfv2-promo-toggle]');
      const status = section.querySelector('[data-rfv2-promo-status]');
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const inEditor = Boolean(window.Shopify && window.Shopify.designMode);
      let active = 0;
      let paused = true;
      let visible = false;
      let interval = null;
      let scheduled = false;
      let observer = null;
      if (nav) nav.hidden = false;
      if (arrows) arrows.hidden = false;
      const pauseLabel = () => {
        if (!toggle) return;
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? 'Play automatic offer slides' : 'Pause automatic offer slides');
        toggle.textContent = paused ? 'Play' : 'Pause';
      };
      const currentIndex = () => {
        const center = rail.getBoundingClientRect().left + rail.clientWidth / 2;
        let nearest = 0;
        let nearestDistance = Infinity;
        slides.forEach((slide, i) => {
          const rect = slide.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - center);
          if (distance < nearestDistance) { nearest = i; nearestDistance = distance; }
        });
        return nearest;
      };
      const update = () => {
        active = currentIndex();
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-current', i === active);
          if (i === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      const goTo = (index, manual = false) => {
        const nextIndex = (index + slides.length) % slides.length;
        const slide = slides[nextIndex];
        if (manual) {
          paused = true;
          pauseLabel();
          if (status) status.textContent = 'Showing offer ' + (nextIndex + 1) + ' of ' + slides.length;
        }
        const x = slide.offsetLeft - (rail.clientWidth - slide.offsetWidth) / 2;
        rail.scrollTo({left:x,behavior:prefersReduced.matches ? 'auto' : 'smooth'});
        active = nextIndex;
        slides.forEach((card, i) => card.classList.toggle('is-active', i === nextIndex));
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-current', i === nextIndex);
          if (i === nextIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      const stop = () => { if (interval !== null) { clearInterval(interval); interval = null; } };
      const canPlay = () => visible && !paused && !prefersReduced.matches && !inEditor && !document.hidden && !section.matches(':hover') && !section.contains(document.activeElement);
      const refresh = () => {
        stop();
        if (canPlay()) interval = window.setInterval(() => goTo(active + 1), 7200);
      };
      const prev = section.querySelector('[data-rfv2-promo-prev]');
      const next = section.querySelector('[data-rfv2-promo-next]');
      prev?.addEventListener('click', () => { goTo(active - 1, true); refresh(); });
      next?.addEventListener('click', () => { goTo(active + 1, true); refresh(); });
      dots.forEach((dot,i) => dot.addEventListener('click', () => { goTo(i, true); refresh(); }));
      toggle?.addEventListener('click', () => { paused = !paused; pauseLabel(); refresh(); });
      rail.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; update(); });
      }, {passive:true});
      rail.addEventListener('pointerdown', () => { paused = true; pauseLabel(); refresh(); }, {passive:true});
      rail.addEventListener('keydown', (e) => {
        if (e.target !== rail) return;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          goTo(active + (e.key === 'ArrowRight' ? 1 : -1), true);
          refresh();
        }
      });
      section.addEventListener('mouseenter', refresh);
      section.addEventListener('mouseleave', refresh);
      section.addEventListener('focusin', refresh);
      section.addEventListener('focusout', () => requestAnimationFrame(refresh));
      document.addEventListener('visibilitychange', refresh);
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          visible = entries.some((entry) => entry.isIntersecting);
          refresh();
        }, {threshold:.35});
        observer.observe(section);
      } else { visible = true; }
      rail.scrollLeft = 0;
      pauseLabel();
      update();
      refresh();
      const onUnload = (event) => {
        if (!event.target.contains(section)) return;
        stop();
        observer?.disconnect();
        document.removeEventListener('visibilitychange', refresh);
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:unload', onUnload);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-jev-assistant"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-rf-jev-assistant]');
  if (!root) return;

  const languageKey = 'rf_assistant_language';
  const browserKey = 'rf_browser_language';
  const visitorKey = 'rf_visitor_id';
  const firstSeenKey = 'rf_visitor_first_seen';
  const stateKey = 'rf_customer_state';
  const successContextKey = 'rf-online-enquiry-success-context:v1';
  const jevSyncPath = '/apps/jev/jev-session';
  const jevSyncReasons = new Set(['first_answer', 'prompt_accepted', 'recommendations_updated', 'recommendation_compare', 'recommendation_ask_price', 'enquiry_submitted', 'return_visit']);
  const observationEnabled = root.dataset.rfObservationEnabled === 'true';
  let jevRequestSequence = 0;

  const languageStep = root.querySelector('[data-rf-language-step]');
  const questionStep = root.querySelector('[data-rf-question-step]');
  const langTitle = root.querySelector('[data-rf-lang-title]');
  const langKicker = root.querySelector('[data-rf-lang-kicker]');
  const questionTitle = root.querySelector('[data-rf-question-title]');
  const questionKicker = root.querySelector('[data-rf-question-kicker]');
  const roomChoices = root.querySelector('[data-rf-room-choices]');
  const freeLabel = root.querySelector('[data-rf-free-label]');
  const freeText = root.querySelector('[data-rf-free-text]');
  const continueButton = root.querySelector('[data-rf-continue]');
  const stage1Form = root.querySelector('[data-rf-stage1-form]');
  const stage1Counter = root.querySelector('[data-rf-stage1-counter]');
  const stage1Progress = root.querySelector('[data-rf-stage1-progress]');
  const stage1Hint = root.querySelector('[data-rf-stage1-hint]');
  const stage1Options = root.querySelector('[data-rf-stage1-options]');
  const stage1Review = root.querySelector('[data-rf-stage1-review]');
  const stage1Error = root.querySelector('[data-rf-stage1-error]');
  const stage1Back = root.querySelector('[data-rf-stage1-back]');
  const stage1Next = root.querySelector('[data-rf-stage1-next]');
  const decisionPrompt = root.querySelector('[data-rf-decision-prompt]');
  const promptMessage = root.querySelector('[data-rf-prompt-message]');
  const promptAccept = root.querySelector('[data-rf-prompt-accept]');
  const promptLater = root.querySelector('[data-rf-prompt-later]');
  const promptDismiss = root.querySelector('[data-rf-prompt-dismiss]');
  const conversation = root.querySelector('[data-rf-conversation]');
  const conversationMain = root.querySelector('[data-rf-conversation-main]');
  const launcher = root.querySelector('[data-rf-jev-launcher]');
  const conversationTitle = root.querySelector('[data-rf-conversation-title]');
  const conversationBody = root.querySelector('[data-rf-conversation-body]');
  const answerSummary = root.querySelector('[data-rf-answer-summary]');
  const conversationChoices = root.querySelector('[data-rf-conversation-choices]');
  const recommendations = root.querySelector('[data-rf-recommendations]');
  const recommendationActions = root.querySelector('[data-rf-recommendation-actions]');
  const conversationLabel = root.querySelector('[data-rf-conversation-label]');
  const conversationText = root.querySelector('[data-rf-conversation-text]');
  const conversationSend = root.querySelector('[data-rf-conversation-send]');
  const conversationClose = root.querySelector('[data-rf-conversation-close]');
  const browserLanguage = navigator.languages?.[0] || navigator.language || 'en';
  localStorage.setItem(browserKey, browserLanguage);

  let visitorId = localStorage.getItem(visitorKey);
  const isReturningVisitor = Boolean(visitorId);

  if (!visitorId) {
    visitorId = 'rf-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    localStorage.setItem(visitorKey, visitorId);
    localStorage.setItem(firstSeenKey, new Date().toISOString());
  }

  root.dataset.rfVisitorId = visitorId;
  root.dataset.rfReturningVisitor = isReturningVisitor ? 'true' : 'false';

  const loadState = () => {
    try {
      return JSON.parse(localStorage.getItem(stateKey)) || {};
    } catch (error) {
      return {};
    }
  };

  const saveState = (patch = {}) => {
    const current = loadState();
    const next = {
      ...current,
      ...patch,
      visitorId,
      isReturningVisitor,
      browserLanguage,
      updatedAt: new Date().toISOString()
    };
    localStorage.setItem(stateKey, JSON.stringify(next));
    return next;
  };

  const cleanLegacyObservationState = () => {
    const current = loadState();
    const legacyKeys = [
      'currentPath',
      'filters',
      'filterSignature',
      'filterChangeCount',
      'collectionHistory',
      'currentCollection',
      'currentProductPath',
      'behaviourSummary',
      'decision',
      'productsViewed',
      'lastProductViewed',
      'coloursViewed',
      'lastColourViewed',
      'enquiryIntentCount'
    ];
    if (!legacyKeys.some((key) => Object.prototype.hasOwnProperty.call(current, key))) return;

    const cleaned = { ...current };
    legacyKeys.forEach((key) => delete cleaned[key]);
    localStorage.setItem(stateKey, JSON.stringify(cleaned));
  };

  cleanLegacyObservationState();

  const cleanLegacyCandidatePoolState = () => {
    const current = loadState();
    const recommendationInput = current.recommendationInput;
    const candidatePool = recommendationInput && recommendationInput.candidatePool;
    if (!candidatePool || !Array.isArray(candidatePool.products)) return;

    const cleanedInput = {
      ...recommendationInput,
      candidatePool: {
        source: 'conversation_global',
        productCount: candidatePool.products.length
      }
    };
    localStorage.setItem(stateKey, JSON.stringify({
      ...current,
      recommendationInput: cleanedInput
    }));
  };

  cleanLegacyCandidatePoolState();

  const buildRufusV2State = (state = loadState()) => {
    const existing = state.rufusV2 && typeof state.rufusV2 === 'object' ? state.rufusV2 : {};
    const explicit = state.needProfile?.explicit || {};
    const priorities = explicit.priorities || {};
    const priorityValues = Object.values(priorities).filter(Boolean);
    const existingNeed = existing.need || {};
    const existingDecision = existing.decision || {};
    const existingFeedback = existing.feedback || {};
    const existingPreferences = existing.preferences || {};
    const existingExceptions = Array.isArray(existing.exceptions) ? existing.exceptions : [];
    const existingTask = existing.task && typeof existing.task === 'object' ? existing.task : {};
    const existingPrice = existing.price || {};
    const existingJourney = existing.journey || {};

    return {
      need: {
        room: normaliseRoomList(explicit.rooms?.length ? explicit.rooms : (explicit.room || existingNeed.room || [])),
        priorities: priorityValues.length ? priorityValues : (Array.isArray(existingNeed.priorities) ? existingNeed.priorities : []),
        pets: existingNeed.pets ?? null,
        kids: existingNeed.kids ?? null,
        traffic: existingNeed.traffic ?? null,
        style: Array.isArray(existingNeed.style) ? existingNeed.style : [],
        brandPreference: existingNeed.brandPreference ?? null,
        budgetPreference: priorities.budget || existingNeed.budgetPreference || null,
        approxAreaM2: Number.isFinite(Number(existingNeed.approxAreaM2)) ? Number(existingNeed.approxAreaM2) : null,
        freeText: explicit.freeText || existingNeed.freeText || '',
        propertyUse: existingNeed.propertyUse ?? null,
        waterProtection: existingNeed.waterProtection ?? null,
        special: Array.isArray(existingNeed.special) ? existingNeed.special : []
      },
      decision: {
        customerClarity: existingDecision.customerClarity || 'unclear',
        informationSufficiency: existingDecision.informationSufficiency || 'low',
        answerLevel: existingDecision.answerLevel || 'ask_more',
        nextAction: existingDecision.nextAction || 'ask_more',
        searchDirection: existingDecision.searchDirection && typeof existingDecision.searchDirection === 'object' ? existingDecision.searchDirection : {},
        feedbackInterpretation: existingDecision.feedbackInterpretation || ''
      },
      feedback: {
        reaction: existingFeedback.reaction || null,
        freeText: existingFeedback.freeText || '',
        confirmedDirection: Boolean(existingFeedback.confirmedDirection),
        confirmedAt: existingFeedback.confirmedAt || null,
        wantsCheaper: Boolean(existingFeedback.wantsCheaper),
        wantsBetterBrand: Boolean(existingFeedback.wantsBetterBrand),
        wantsMoreOptions: Boolean(existingFeedback.wantsMoreOptions),
        wantsDifferentStyle: Boolean(existingFeedback.wantsDifferentStyle),
        wantsCompare: Boolean(existingFeedback.wantsCompare)
      },
      preferences: {
        look: existingPreferences.look || '',
        materialFeel: existingPreferences.materialFeel || '',
        pattern: existingPreferences.pattern || '',
        colour: existingPreferences.colour || '',
        priceDirection: existingPreferences.priceDirection || '',
        brand: existingPreferences.brand || ''
      },
      exceptions: existingExceptions.slice(0, 20),
      task: {
        type: existingTask.type || '',
        referenceTitle: existingTask.referenceTitle || '',
        referencePath: existingTask.referencePath || '',
        keepOriginal: existingTask.keepOriginal ?? null,
        matchAttributes: Array.isArray(existingTask.matchAttributes) ? existingTask.matchAttributes.slice(0, 8) : [],
        updatedAt: existingTask.updatedAt || null
      },
      price: {
        requested: Boolean(existingPrice.requested),
        startingBand: existingPrice.startingBand || null,
        reaction: existingPrice.reaction || null
      },
      journey: {
        status: existingJourney.status || 'active',
        lastShownCollection: existingJourney.lastShownCollection || null,
        lastShownProducts: Array.isArray(existingJourney.lastShownProducts) ? existingJourney.lastShownProducts : []
      },
      requirementStatus: existing.requirementStatus && typeof existing.requirementStatus === 'object'
        ? { ...existing.requirementStatus }
        : {}
    };
  };

  saveState({
    language: localStorage.getItem(languageKey) || '',
    firstSeenAt: localStorage.getItem(firstSeenKey) || '',
    rufusV2: buildRufusV2State()
  });

  const isExplicitNeedStatement = (text = '') => {
    const value = String(text || '').trim();
    if (!value) return false;
    return /\b(i\s+(?:still\s+)?(?:need|want|prefer|require)|must\s+be|important\s+to\s+me|my\s+budget|i(?:'|’)m\s+looking\s+for|looking\s+for)\b/i.test(value)
      || /(?:我(?:仍然|还是)?(?:需要|想要|喜欢|偏好)|必须|预算|对我很重要|我在找)/.test(value);
  };

  const mergeExplicitNeedStatement = (text = '') => {
    const value = String(text || '').trim();
    if (!isExplicitNeedStatement(value)) return false;
    const state = loadState();
    const currentV2 = buildRufusV2State(state);
    const existingText = String(currentV2.need.freeText || state.needProfile?.explicit?.freeText || '').trim();
    const mergedText = existingText && !existingText.toLowerCase().includes(value.toLowerCase())
      ? `${existingText}. ${value}`
      : (existingText || value);
    const needProfile = {
      explicit: {
        ...(state.needProfile?.explicit || {}),
        room: state.needProfile?.explicit?.room || state.room || '',
        priorities: { ...(state.needProfile?.explicit?.priorities || {}) },
        freeText: mergedText
      },
      updatedAt: new Date().toISOString()
    };
    saveState({
      needProfile,
      rufusV2: {
        ...currentV2,
        need: {
          ...currentV2.need,
          freeText: mergedText
        }
      }
    });
    return true;
  };

  const removeRequirementFromNeedState = (kind = '') => {
    const state = loadState();
    const currentV2 = buildRufusV2State(state);
    const explicit = state.needProfile?.explicit || {};
    const priorities = { ...(explicit.priorities || {}) };
    const removeMatchingPriority = (pattern) => {
      Object.keys(priorities).forEach((key) => {
        if (pattern.test(String(priorities[key] || ''))) delete priorities[key];
      });
    };
    let free = String(currentV2.need.freeText || explicit.freeText || '');
    if (kind === 'waterproof') {
      removeMatchingPriority(/water|防水|耐水/i);
      free = free
        .replace(/\b(?:must\s+be\s+)?waterproof\b/ig, '')
        .replace(/\bwater[-\s]?resistan(?:t|ce)\b/ig, '')
        .replace(/(?:必须)?防水|耐水/ig, '');
    } else if (kind === 'timber') {
      removeMatchingPriority(/timber|hardwood|real\s*wood|天然木|实木/i);
      free = free
        .replace(/\b(?:real\s+)?timber\b/ig, '')
        .replace(/\bhardwood\b/ig, '')
        .replace(/\breal\s+wood\b/ig, '')
        .replace(/天然木|实木/ig, '');
    }
    free = free.replace(/\s{2,}/g, ' ').replace(/\s+([,.])/g, '$1').replace(/^[\s.,;:-]+|[\s.,;:-]+$/g, '').trim();
    const needProfile = {
      explicit: {
        ...explicit,
        priorities,
        freeText: free
      },
      updatedAt: new Date().toISOString()
    };
    saveState({
      needProfile,
      rufusV2: {
        ...currentV2,
        need: {
          ...currentV2.need,
          priorities: Object.values(priorities).filter(Boolean),
          freeText: free
        }
      }
    });
  };

  const refreshNeedProfile = (rankAfter = true) => {
    const state = loadState();
    const action = state.conversationAction || '';
    const choice = state.conversationChoice || '';
    const previousExplicit = state.needProfile?.explicit || {};
    const stableNeed = state.rufusV2?.need || {};
    const rooms = normaliseRoomList(state.rooms?.length ? state.rooms : (state.room || previousExplicit.rooms || previousExplicit.room || stableNeed.room || []));
    const explicit = {
      room: rooms.join(', '),
      rooms,
      freeText: stableNeed.freeText || previousExplicit.freeText || state.freeText || '',
      priorities: { ...(previousExplicit.priorities || {}) }
    };

    if (action === 'type_help' && choice) explicit.priorities.type = choice;
    if (action === 'budget_help' && choice) explicit.priorities.budget = choice;
    if (action === 'offer_help' && choice) explicit.priorities.general = choice;
    if (action === 'high_intent_support' && choice) explicit.nextStep = choice;

    const needProfile = {
      explicit,
      updatedAt: new Date().toISOString()
    };
    saveState({
      needProfile,
      rufusV2: buildRufusV2State({ ...state, needProfile })
    });
    window.setTimeout(() => refreshRecommendationInput({ rank: rankAfter }), 0);
  };

  const extractCollectionCandidates = (scope = document, limit = 30) => Array.from(scope.querySelectorAll('[data-tcvc-product-title]')).slice(0, limit).map((row) => {
    const spec = (name) => row.querySelector(`[data-tcvb-spec="${name}"]`)?.textContent.trim() || '';
    const colours = (row.getAttribute('data-tcvb-colours') || '')
      .split(';;;')
      .map((entry) => entry.split('|||')[0]?.trim())
      .filter(Boolean)
      .slice(0, 12);
    const publicPriceText = spec('price');
    return {
      title: row.getAttribute('data-tcvc-product-title') || '',
      url: row.getAttribute('data-tcvc-product-url') || '',
      vendor: row.getAttribute('data-tcvc-vendor') || '',
      flooringType: row.getAttribute('data-tcvc-flooring-type') || '',
      acRating: row.getAttribute('data-tcvc-ac-rating') || '',
      boardSizes: (row.getAttribute('data-tcvc-board-sizes') || '').split('|').map((value) => value.trim()).filter(Boolean).slice(0, 6),
      pattern: spec('pattern'),
      waterResistance: spec('water'),
      thickness: row.getAttribute('data-tcvb-thickness') || spec('thickness'),
      publicPriceText,
      priceBand: row.getAttribute('data-tcvb-price-range') || '',
      priceVisibility: publicPriceText.toLowerCase().includes('enquire') ? 'enquire' : 'public',
      colours
    };
  }).filter((product) => product.title);

  let runtimeCandidatePool = {
    source: 'conversation_global',
    products: []
  };
  let expandedCandidatePoolPromise = null;
  let expandedCandidatePoolLoaded = false;
  let pendingExplicitReference = null;
  let runtimeReferenceGuideProduct = null;

  const serviceAreaRegions = ['Greater Brisbane', 'Redlands', 'Logan', 'Ipswich', 'North Gold Coast', 'South Caboolture'];

  const detectServiceArea = (text = '') => {
    const value = String(text || '').trim();
    if (!value) return { status: 'unknown', matchedRegion: '' };
    const lower = value.toLowerCase();
    const insideChecks = [
      ['Greater Brisbane', /\bbrisbane\b/i],
      ['Redlands', /\bredlands?\b|\bcleveland\b|\bcapalaba\b/i],
      ['Logan', /\blogan\b/i],
      ['Ipswich', /\bipswich\b/i],
      ['North Gold Coast', /\bgold coast\b|\bcoomera\b|\bhelensvale\b|\boxenford\b/i],
      ['South Caboolture', /\bcaboolture\b|\bmoreton bay\b/i]
    ];
    const inside = insideChecks.find(([, pattern]) => pattern.test(value));
    if (inside) return { status: 'inside', matchedRegion: inside[0] };

    if (/\b(interstate|sydney|melbourne|adelaide|perth|darwin|hobart|canberra|new south wales|nsw|victoria|vic|south australia|sa|western australia|wa|tasmania|tas|northern territory|nt|act)\b/i.test(lower)) {
      return { status: 'outside', matchedRegion: '' };
    }
    return { status: 'unknown', matchedRegion: '' };
  };

  const parseCurrentProductCandidate = (scope = document) => {
    const script = scope.querySelector('[data-rf-current-product-candidate]');
    if (!script) return null;
    try {
      const product = JSON.parse(script.textContent || '{}');
      return product?.title ? product : null;
    } catch (_error) {
      return null;
    }
  };

  const currentReferenceContext = () => {
    const path = window.location.pathname.replace(/\/$/, '') || '/';
    if (path.startsWith('/products/')) {
      const product = parseCurrentProductCandidate(document);
      return product ? { type: 'product', title: product.title, path, products: [product] } : null;
    }
    if (path.startsWith('/collections/')) {
      const products = extractCollectionCandidates(document, 100);
      if (!products.length) return null;
      const handleTitle = decodeURIComponent(path.split('/').filter(Boolean).pop() || '')
        .replace(/-/g, ' ')
        .replace(/\b\w/g, (letter) => letter.toUpperCase());
      const title = document.querySelector('h1')?.textContent?.trim() || handleTitle || 'this collection';
      return { type: 'collection', title, path, products };
    }
    return null;
  };

  const explicitlyRefersToCurrentPage = (text = '') => /\b(this product|this one|this page|these products|these ones|products on this page|compare these|compare this|which of these|which one here)\b/i.test(text)
    || /这个产品|这个页面|这一页|这些产品|这几个|比较这些|这里的产品/.test(text);

  const isSimilarityRequest = (text = '') => /\b(similar to (?:this|it)|something (?:similar|like this)|other products? like this|alternatives? like this|similar options?)\b/i.test(String(text || ''))
    || /类似这个|相似的产品|差不多的产品|类似的选择|相似选择/.test(String(text || ''));

  const pastedProductUrl = (text = '') => String(text || '').match(/https?:\/\/[^\s]+\/products\/[^\s?#]+|\/products\/[^\s?#]+/i)?.[0] || '';

  const loadProductFromUrl = async (url) => {
    try {
      const target = new URL(url, window.location.origin);
      if (target.origin !== window.location.origin || !target.pathname.startsWith('/products/')) return null;
      const response = await fetch(scopedFetchUrl(target.pathname), { credentials: 'same-origin' });
      if (!response.ok) return null;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      return parseCurrentProductCandidate(doc);
    } catch (_error) {
      return null;
    }
  };

  const scopedFetchUrl = (path) => {
    const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (!previewThemeId) return path;
    const url = new URL(path, window.location.origin);
    url.searchParams.set('preview_theme_id', previewThemeId);
    return `${url.pathname}${url.search}`;
  };

  const mergeCandidateGroups = (groups, limit = 150) => {
    const output = [];
    const seen = new Set();
    const queues = groups.map((group) => Array.isArray(group) ? [...group] : []);
    let added = true;
    while (output.length < limit && added) {
      added = false;
      queues.forEach((queue) => {
        if (output.length >= limit || !queue.length) return;
        const product = queue.shift();
        const key = product?.url || product?.title || '';
        if (!key || seen.has(key)) return;
        seen.add(key);
        output.push(product);
        added = true;
      });
    }
    return output;
  };

  const filterCandidatesByConversation = (products, state = loadState()) => {
    const explicit = state.needProfile?.explicit || {};
    const priorityText = Object.values(explicit.priorities || {}).join(' ').toLowerCase();
    const notes = String(explicit.freeText || '').toLowerCase();
    const combined = `${priorityText} ${notes}`;
    const requestedTypes = [];

    if (combined.includes('hybrid') || combined.includes('spc')) requestedTypes.push('hybrid');
    if (combined.includes('laminate')) requestedTypes.push('laminate');
    if (combined.includes('vinyl')) requestedTypes.push('vinyl');
    if (combined.includes('engineered timber') || combined.includes('engineered wood')) requestedTypes.push('engineered');
    if (combined.includes('solid timber') || combined.includes('solid wood')) requestedTypes.push('solid');
    if (combined.includes('bamboo')) requestedTypes.push('bamboo');

    let filtered = Array.isArray(products) ? products : [];

    if (requestedTypes.length) {
      filtered = filtered.filter((product) => {
        const type = String(product.flooringType || '').toLowerCase();
        const title = String(product.title || '').toLowerCase();
        return requestedTypes.some((requestedType) => {
          if (requestedType === 'engineered') return type.includes('engineered') || title.includes('engineered');
          if (requestedType === 'solid') return type.includes('solid') || title.includes('solid timber');
          return type.includes(requestedType) || title.includes(requestedType);
        });
      });
    }

    if (notes.includes('waterproof') || notes.includes('must be waterproof') || notes.includes('防水')) {
      filtered = filtered.filter((product) => String(product.waterResistance || '').toLowerCase().includes('waterproof'));
    }

    if (priorityText.includes('lower budget') || priorityText.includes('预算低一些')) {
      filtered = filtered.filter((product) => {
        const band = String(product.priceBand || '').trim();
        return band === '$' || band === '$$';
      });
    }

    const requestedPatterns = ['herringbone', 'chevron', 'parquet'].filter((pattern) => combined.includes(pattern));
    if (requestedPatterns.length) {
      filtered = filtered.filter((product) => {
        const pattern = String(product.pattern || '').toLowerCase();
        const title = String(product.title || '').toLowerCase();
        return requestedPatterns.some((requestedPattern) => pattern.includes(requestedPattern) || title.includes(requestedPattern));
      });
    }

    // A referenced product is only a temporary comparison/search guide. It never rewrites Need State.
    // When the customer explicitly asks for "similar" alternatives, narrow by the attribute they chose,
    // but only when that still leaves a useful set. Existing hard requirements (e.g. waterproof) stay first.
    const task = state.rufusV2?.task || {};
    const guide = state.referenceGuide || {};
    const attribute = Array.isArray(task.matchAttributes) ? task.matchAttributes[0] : '';
    if (task.type === 'find_similar' && guide.title && attribute && filtered.length) {
      const guidePattern = String(guide.pattern || '').toLowerCase();
      const guideVendor = String(guide.vendor || '').toLowerCase();
      const guideType = String(guide.flooringType || '').toLowerCase();
      const guidePrice = String(guide.priceBand || '').trim();
      const guideBoard = String(guide.boardSize || '').toLowerCase();
      const guideColours = new Set((Array.isArray(guide.colours) ? guide.colours : []).map((value) => String(value || '').toLowerCase()).filter(Boolean));
      const similar = filtered.filter((product) => {
        const pattern = String(product.pattern || '').toLowerCase();
        const vendor = String(product.vendor || '').toLowerCase();
        const type = String(product.flooringType || '').toLowerCase();
        const price = String(product.priceBand || '').trim();
        const boards = (Array.isArray(product.boardSizes) ? product.boardSizes : []).map((value) => String(value || '').toLowerCase());
        const colours = (Array.isArray(product.colours) ? product.colours : []).map((value) => String(value || '').toLowerCase());
        const sharesColour = colours.some((value) => guideColours.has(value));
        if (attribute === 'pattern') return Boolean(guidePattern && pattern === guidePattern);
        if (attribute === 'brand') return Boolean(guideVendor && vendor === guideVendor);
        if (attribute === 'price') return Boolean(guidePrice && price === guidePrice);
        if (attribute === 'boardSize') return Boolean(guideBoard && boards.includes(guideBoard));
        if (attribute === 'materialFeel') return Boolean(guideType && type === guideType);
        if (attribute === 'look') return Boolean((guidePattern && pattern === guidePattern) || sharesColour);
        if (attribute === 'overallStyle') return Boolean((guidePattern && pattern === guidePattern) || (guideType && type === guideType) || sharesColour);
        return true;
      });
      if (similar.length >= 2) filtered = similar;
    }

    return filtered;
  };

  const loadExpandedCandidatePool = async () => {
    if (expandedCandidatePoolLoaded) return runtimeCandidatePool;
    if (expandedCandidatePoolPromise) return expandedCandidatePoolPromise;

    expandedCandidatePoolPromise = (async () => {
      const parser = new DOMParser();
      try {
        const hubResponse = await fetch(scopedFetchUrl('/collections/floorboards'), { credentials: 'same-origin' });
        if (!hubResponse.ok) throw new Error('floorboards hub unavailable');
        const hubDocument = parser.parseFromString(await hubResponse.text(), 'text/html');
        const collectionUrls = [...new Set([
          ...Array.from(hubDocument.querySelectorAll('[data-type-card][data-type-url]'))
            .map((card) => card.getAttribute('data-type-url') || '')
            .filter((url) => url.startsWith('/collections/') && url !== '/collections/floorboards'),
          '/collections/solid-timber-flooring',
          '/collections/bamboo-flooring'
        ])];
        if (!collectionUrls.length) throw new Error('floorboards collections unavailable');

        const collectionGroups = await Promise.all(collectionUrls.map(async (url) => {
          try {
            const response = await fetch(scopedFetchUrl(url), { credentials: 'same-origin' });
            if (!response.ok) return [];
            const doc = parser.parseFromString(await response.text(), 'text/html');
            return extractCollectionCandidates(doc, 100);
          } catch (_error) {
            return [];
          }
        }));

        const globalProducts = mergeCandidateGroups(collectionGroups, 150);
        const scopedProducts = filterCandidatesByConversation(globalProducts);
        if (scopedProducts.length) {
          runtimeCandidatePool = {
            source: 'conversation_global',
            products: scopedProducts
          };
          expandedCandidatePoolLoaded = true;
          return runtimeCandidatePool;
        }
      } catch (_error) {
      }

      runtimeCandidatePool = {
        source: 'conversation_global',
        products: []
      };
      return runtimeCandidatePool;
    })().finally(() => {
      expandedCandidatePoolPromise = null;
    });

    return expandedCandidatePoolPromise;
  };

  const refreshRecommendationInput = ({ rank = true } = {}) => {
    const state = loadState();
    const profile = state.needProfile || {};
    const explicit = profile.explicit || {};
    const stage1 = state.enq10qaStage1;
    const stage1Answers = stage1?.answers || {};
    const stage1Priorities = stage1?.completedAt ? {
      property_use: (stage1Answers.property_use || []).join(','),
      water: (stage1Answers.water || []).join(','),
      main: (stage1Answers.priority || []).join(','),
      look: (stage1Answers.look || []).join(','),
      special: (stage1Answers.special || []).join(',')
    } : null;
    const recommendationInput = {
      language: state.language || 'en',
      explicitNeeds: {
        room: stage1?.completedAt ? (stage1Answers.room || []).join(',') : (explicit.room || ''),
        priorities: stage1Priorities || explicit.priorities || {},
        nextStep: explicit.nextStep || '',
        customerNotes: stage1?.completedAt ? (stage1.freeText || '') : (explicit.freeText || '')
      },
      candidatePool: {
        source: runtimeCandidatePool.source || 'conversation_global',
        productCount: runtimeCandidatePool.products.length
      }
    };

    saveState({ recommendationInput });
    if (rank && stage1?.completedAt && stage1?.phase !== 'type_guide') {
      window.setTimeout(refreshCandidateRanking, 0);
    }
    return recommendationInput;
  };

  const setConversationChoices = (choices = []) => {
    if (!conversationChoices) return;
    conversationChoices.replaceChildren();
    choices.forEach((choice) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--secondary';
      button.textContent = choice;
      button.dataset.rfConversationChoice = choice;
      button.setAttribute('aria-pressed', 'false');
      conversationChoices.appendChild(button);
    });
  };

  const showReferenceConfirmation = (reference) => {
    if (!reference || !conversation) return false;
    const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    pendingExplicitReference = reference;
    languageStep.hidden = true;
    questionStep.hidden = true;
    conversationMain.hidden = false;
    conversation.hidden = false;
    launcher.hidden = true;
    conversation.dataset.rfAction = 'reference_confirm';
    conversation.dataset.rfQuestionKey = '';
    const isCollection = reference.type === 'collection';
    conversationBody.textContent = language === 'zh'
      ? `你指的是现在页面里的${isCollection ? '产品列表' : '产品'}“${reference.title}”吗？`
      : `Do you mean ${isCollection ? 'the products in' : 'the product'} “${reference.title}” currently open on this page?`;
    setConversationChoices(language === 'zh' ? ['是', '不是'] : ['Yes', 'No']);
    recommendations.hidden = true;
    recommendationActions.hidden = true;
    conversationLabel.textContent = language === 'zh' ? '也可以补充说明' : 'You can also clarify what you mean';
    conversationSend.textContent = language === 'zh' ? '继续' : 'Continue';
    conversationText.value = '';
    return true;
  };

  const activateExplicitReference = (reference) => {
    if (!reference || !Array.isArray(reference.products) || !reference.products.length) return false;
    runtimeCandidatePool = {
      source: reference.type === 'collection' ? 'explicit_collection_reference' : 'explicit_product_reference',
      products: reference.products.slice(0, 150)
    };
    const state = loadState();
    const currentV2 = buildRufusV2State(state);
    saveState({
      explicitReference: {
        type: reference.type,
        title: reference.title,
        path: reference.path || '',
        confirmed: true,
        productCount: runtimeCandidatePool.products.length
      },
      rufusV2: {
        ...currentV2,
        task: {
          ...currentV2.task,
          type: reference.type === 'collection' ? 'inspect_collection' : 'inspect_product',
          referenceTitle: reference.title,
          referencePath: reference.path || '',
          updatedAt: new Date().toISOString()
        },
        feedback: {
          ...currentV2.feedback,
          reaction: 'reference_confirmed'
        }
      },
      recommendationPresentation: { method: 'jev_backend_v1', products: [] },
      recommendationResult: null,
      candidateRanking: { method: 'deterministic_v1', shortlist: [], evaluatedCount: 0, eligibleCount: 0 },
      recommendationInput: {
        ...(state.recommendationInput || {}),
        candidatePool: {
          source: runtimeCandidatePool.source,
          productCount: runtimeCandidatePool.products.length
        }
      }
    });
    return true;
  };

  const activateReferenceAsGuide = (reference) => {
    if (!reference || reference.type !== 'product' || !Array.isArray(reference.products) || !reference.products.length) return false;
    const state = loadState();
    const currentV2 = buildRufusV2State(state);
    runtimeCandidatePool = { source: 'conversation_global', products: [] };
    expandedCandidatePoolLoaded = false;
    const guideProduct = reference.products[0] || {};
    runtimeReferenceGuideProduct = guideProduct;
    saveState({
      explicitReference: {
        type: 'product',
        title: reference.title,
        path: reference.path || '',
        confirmed: true,
        productCount: 1,
        mode: 'reference_only'
      },
      referenceGuide: {
        title: reference.title,
        vendor: guideProduct.vendor || '',
        flooringType: guideProduct.flooringType || '',
        pattern: guideProduct.pattern || '',
        priceBand: guideProduct.priceBand || '',
        boardSize: Array.isArray(guideProduct.boardSizes) ? (guideProduct.boardSizes[0] || '') : '',
        colours: Array.isArray(guideProduct.colours) ? guideProduct.colours.slice(0, 6) : []
      },
      rufusV2: {
        ...currentV2,
        task: {
          ...currentV2.task,
          type: 'find_similar',
          referenceTitle: reference.title,
          referencePath: reference.path || '',
          keepOriginal: null,
          matchAttributes: [],
          updatedAt: new Date().toISOString()
        },
        feedback: {
          ...currentV2.feedback,
          reaction: 'reference_similar_request'
        }
      },
      recommendationPresentation: { method: 'jev_backend_v1', products: [] },
      recommendationResult: null,
      candidateRanking: { method: 'deterministic_v1', shortlist: [], evaluatedCount: 0, eligibleCount: 0 }
    });
    return true;
  };

  const clearExplicitReference = () => {
    pendingExplicitReference = null;
    runtimeReferenceGuideProduct = null;
    runtimeCandidatePool = { source: 'conversation_global', products: [] };
    expandedCandidatePoolLoaded = false;
    const state = loadState();
    const currentV2 = buildRufusV2State(state);
    const cleaned = {
      ...state,
      rufusV2: {
        ...currentV2,
        task: {
          ...currentV2.task,
          type: '',
          referenceTitle: '',
          referencePath: '',
          keepOriginal: null,
          matchAttributes: [],
          updatedAt: new Date().toISOString()
        }
      },
      recommendationPresentation: { method: 'jev_backend_v1', products: [] },
      recommendationResult: null,
      candidateRanking: { method: 'deterministic_v1', shortlist: [], evaluatedCount: 0, eligibleCount: 0 }
    };
    delete cleaned.explicitReference;
    delete cleaned.referenceGuide;
    localStorage.setItem(stateKey, JSON.stringify(cleaned));
  };

  const maybePrepareExplicitReference = async (message) => {
    const similarityIntent = isSimilarityRequest(message);
    const pastedUrl = pastedProductUrl(message);
    if (pastedUrl) {
      const product = await loadProductFromUrl(pastedUrl);
      if (product) return showReferenceConfirmation({ type: 'product', title: product.title, path: product.url || pastedUrl, products: [product], intent: similarityIntent ? 'find_similar' : 'inspect_product' });
    }

    if (explicitlyRefersToCurrentPage(message)) {
      const reference = currentReferenceContext();
      if (reference) return showReferenceConfirmation({ ...reference, intent: similarityIntent && reference.type === 'product' ? 'find_similar' : (reference.type === 'collection' ? 'inspect_collection' : 'inspect_product') });
      const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
      conversationBody.textContent = language === 'zh'
        ? '我现在无法确定你指的是哪个产品。请打开对应的产品页面或产品列表页面，或者把产品名称/链接贴给我。'
        : 'I cannot tell which product you mean from this page. Please open the product page or collection/product list, or paste the product name or link here.';
      recommendations.hidden = true;
      recommendationActions.hidden = true;
      return true;
    }

    const trimmed = String(message || '').trim();
    if (trimmed.length >= 8 && !/\s{3,}/.test(trimmed)) {
      if (!expandedCandidatePoolLoaded) await loadExpandedCandidatePool();
      const lower = trimmed.toLowerCase();
      const match = runtimeCandidatePool.products.find((product) => {
        const title = String(product.title || '').toLowerCase();
        return title && (lower === title || lower.includes(title) || title.includes(lower));
      });
      if (match) return showReferenceConfirmation({ type: 'product', title: match.title, path: match.url || '', products: [match], intent: similarityIntent ? 'find_similar' : 'inspect_product' });
    }
    return false;
  };

  function renderRecommendationCards() {
    if (!recommendations || !recommendationActions || !conversation) return;
    const state = loadState();
    const products = state.recommendationPresentation?.products || [];
    const language = state.language === 'zh' ? 'zh' : 'en';
    const ui = language === 'zh'
      ? {
          view: '查看产品',
          compare: '加入比较',
          askPrice: '询价',
          cheaper: '更便宜的选择',
          timber: '更接近天然木',
          empty: '根据目前的信息，还没有足够合适的产品。你可以再告诉我一些需求。'
        }
      : {
          view: 'View product',
          compare: 'Compare',
          askPrice: 'Ask price',
          cheaper: 'Cheaper options',
          timber: 'More timber-like',
          empty: 'I do not have enough suitable products from the current information yet. Tell me a little more about what you need.'
        };

    recommendations.replaceChildren();
    products.slice(0, 3).forEach((product) => {
      const card = document.createElement('article');
      card.className = 'rf-jev__recommendation-card';

      const label = document.createElement('p');
      label.className = 'rf-jev__recommendation-label';
      label.textContent = product.label || '';

      const title = document.createElement('p');
      title.className = 'rf-jev__recommendation-title';
      title.textContent = product.title || '';

      const explanation = document.createElement('p');
      explanation.className = 'rf-jev__recommendation-copy';
      explanation.textContent = product.explanation || '';

      const meta = document.createElement('p');
      meta.className = 'rf-jev__recommendation-meta';
      meta.textContent = [product.flooringType, product.pattern, product.acRating, product.waterResistance, product.thickness, product.publicPriceText].filter(Boolean).join(' · ');

      const actions = document.createElement('div');
      actions.className = 'rf-jev__recommendation-card-actions';

      const view = document.createElement('a');
      view.className = 'button button--secondary';
      view.href = product.url || '#';
      view.textContent = ui.view;

      const compare = document.createElement('button');
      compare.type = 'button';
      compare.className = 'button button--secondary';
      compare.textContent = ui.compare;
      compare.dataset.rfRecommendationCompare = product.title || '';

      const askPrice = document.createElement('button');
      askPrice.type = 'button';
      askPrice.className = 'button button--secondary';
      askPrice.textContent = ui.askPrice;
      askPrice.dataset.rfRecommendationAskPrice = product.title || '';

      actions.append(view, compare, askPrice);
      card.append(label, title, explanation, meta, actions);
      recommendations.appendChild(card);
    });

    if (!products.length) {
      const empty = document.createElement('p');
      empty.className = 'rf-jev__recommendation-copy';
      empty.textContent = ui.empty;
      recommendations.appendChild(empty);
    }
    recommendations.hidden = false;

    recommendationActions.replaceChildren();
    const nextAction = state.recommendationResult?.nextAction || '';
    if (nextAction === 'staff_follow_up') {
      recommendationActions.hidden = true;
      return;
    }
    const cheaper = document.createElement('button');
    cheaper.type = 'button';
    cheaper.className = 'button button--secondary';
    cheaper.textContent = ui.cheaper;
    cheaper.dataset.rfRecommendationRefine = 'lower_budget';
    const timber = document.createElement('button');
    timber.type = 'button';
    timber.className = 'button button--secondary';
    timber.textContent = ui.timber;
    timber.dataset.rfRecommendationRefine = 'timber';
    recommendationActions.append(cheaper, timber);
    recommendationActions.hidden = false;
  }

  const renderAdaptiveTurn = (result) => {
    if (!conversation || !conversationMain) return;
    const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    const decision = result?.decisionState || loadState().rufusV2?.decision || {};
    const question = result?.question || loadState().recommendationResult?.question || null;
    const serviceAreaNotice = result?.serviceAreaNotice || '';
    const answerLevel = decision.answerLevel || 'ask_more';

    languageStep.hidden = true;
    questionStep.hidden = true;
    conversationMain.hidden = false;
    conversation.hidden = false;
    launcher.hidden = true;
    conversationText.value = '';
    conversationSend.disabled = false;
    renderAnswerSummary();

    if (answerLevel === 'ask_more' && question) {
      conversation.dataset.rfAction = 'v2_question';
      conversation.dataset.rfQuestionKey = question.key || '';
      conversationBody.textContent = [
        question.text || (language === 'zh' ? '再告诉我一点你的需求。' : 'Tell me a little more about what you need.'),
        serviceAreaNotice
      ].filter(Boolean).join(' ');
      setConversationChoices(Array.isArray(question.choices) ? question.choices : []);
      conversationLabel.textContent = language === 'zh' ? '也可以补充说明' : 'Tell me more if you like';
      conversationSend.textContent = language === 'zh' ? '继续' : 'Continue';
      recommendations.hidden = true;
      recommendationActions.hidden = true;
      return;
    }

    conversation.dataset.rfAction = 'v2_feedback';
    conversation.dataset.rfQuestionKey = '';
    conversationBody.textContent = [
      language === 'zh'
        ? '这些是根据你目前明确需求筛出的选择。这个方向目前大致符合你想要的吗？'
        : 'These are the strongest matches from what you have explicitly told me so far. Is this roughly the direction you want at this stage?',
      serviceAreaNotice
    ].filter(Boolean).join(' ');
    renderRecommendationCards();
    recommendationActions.hidden = true;
    setConversationChoices(language === 'zh'
      ? ['看起来不错', '更便宜一点', '更好的品牌', '再看一些', '换一种风格', '帮我比较', '我改变主意了', '还不确定']
      : ['Looks good', 'Cheaper options', 'Better-known brand', 'Show me more', 'Different style', 'Compare these', 'I changed my mind', 'Not sure']);
    conversationLabel.textContent = language === 'zh' ? '也可以告诉我你想怎么调整' : 'Or tell me what you would like to change';
    conversationSend.textContent = language === 'zh' ? '更新选择' : 'Update choices';
  };

  const refreshHandoffPayload = (reason = 'state_update') => {
    const state = loadState();
    const input = state.recommendationInput || {};
    const presentation = state.recommendationPresentation?.products || [];
    const payload = {
      schemaVersion: 1,
      reason,
      visitorId,
      language: state.language || 'en',
      needs: input.explicitNeeds || {},
      observedSummary: {},
      context: {},
      recommendations: presentation.slice(0, 3).map((product) => ({
        title: product.title,
        url: product.url,
        label: product.label,
        explanation: product.explanation,
        publicPriceText: product.publicPriceText,
        priceVisibility: product.priceVisibility
      })),
      lastAction: {
        action: state.lastRecommendationAction || '',
        productTitle: state.lastRecommendationProduct || ''
      },
      enquiry: {
        submitCount: state.enquirySubmitCount || 0,
        lastSubmittedAt: state.lastEnquirySubmittedAt || '',
        products: Array.isArray(state.lastEnquiryProducts) ? state.lastEnquiryProducts : [],
        colours: Array.isArray(state.lastEnquiryColours) ? state.lastEnquiryColours : [],
        source: state.lastEnquirySource || ''
      },
      decisionState: state.rufusV2?.decision || {},
      feedback: state.rufusV2?.feedback || {},
      preferences: state.rufusV2?.preferences || {},
      exceptions: state.rufusV2?.exceptions || [],
      taskContext: state.rufusV2?.task || {},
      priceState: state.rufusV2?.price || {},
      journeyState: state.rufusV2?.journey || {},
      referenceContext: state.explicitReference || {},
      serviceArea: state.serviceArea || { status: 'unknown', matchedRegion: '' },
      pagePath: ''
    };

    saveState({ handoffPayload: payload });
    document.dispatchEvent(new CustomEvent('rf:assistant:handoff-ready', {
      detail: { reason, payload }
    }));
    return payload;
  };

  const buildJevRequestPayload = (payload) => ({
    ...payload,
    runtimeCandidates: {
      source: runtimeCandidatePool.source || 'conversation_global',
      products: (Array.isArray(runtimeCandidatePool.products) ? runtimeCandidatePool.products : [])
        .slice(0, 150)
        .map((product) => ({
          title: product.title || '',
          url: product.url || '',
          vendor: product.vendor || '',
          flooringType: product.flooringType || '',
          acRating: product.acRating || '',
          boardSizes: Array.isArray(product.boardSizes) ? product.boardSizes.slice(0, 4) : [],
          pattern: product.pattern || '',
          waterResistance: product.waterResistance || '',
          thickness: product.thickness || '',
          publicPriceText: product.publicPriceText || '',
          priceBand: product.priceBand || '',
          priceVisibility: product.priceVisibility || '',
          colours: Array.isArray(product.colours) ? product.colours.slice(0, 20) : []
        }))
    }
  });

  const applyJevDecision = (result) => {
    if (loadState().enq10qaStage1?.phase === 'type_guide') return;
    if (!result || result.ok !== true || !Array.isArray(result.recommendations)) return;
    const products = result.recommendations.slice(0, 3).map((recommendation) => {
      const runtimeProduct = (runtimeCandidatePool.products || []).find((product) =>
        (recommendation.url && product.url === recommendation.url) ||
        (recommendation.title && product.title === recommendation.title)
      ) || {};
      return {
        title: recommendation.title || runtimeProduct.title || '',
        url: recommendation.url || runtimeProduct.url || '',
        label: recommendation.label || '',
        explanation: recommendation.explanation || '',
        score: Number(recommendation.score) || 0,
        flooringType: runtimeProduct.flooringType || '',
        pattern: runtimeProduct.pattern || '',
        acRating: runtimeProduct.acRating || '',
        waterResistance: runtimeProduct.waterResistance || '',
        thickness: runtimeProduct.thickness || '',
        publicPriceText: runtimeProduct.publicPriceText || '',
        priceVisibility: runtimeProduct.priceVisibility || ''
      };
    }).filter((product) => product.title);

    const decisionState = result.decisionState && typeof result.decisionState === 'object'
      ? {
          customerClarity: result.decisionState.customerClarity || 'unclear',
          informationSufficiency: result.decisionState.informationSufficiency || 'low',
          answerLevel: result.decisionState.answerLevel || 'ask_more',
          nextAction: result.decisionState.nextAction || result.nextAction || 'ask_more',
          searchDirection: result.searchDirection && typeof result.searchDirection === 'object' ? result.searchDirection : {},
          feedbackInterpretation: result.feedbackInterpretation || ''
        }
      : {
          customerClarity: 'unclear',
          informationSufficiency: 'low',
          answerLevel: products.length ? (products.length === 1 ? 'product' : 'shortlist') : 'ask_more',
          nextAction: result.nextAction || 'ask_more',
          searchDirection: result.searchDirection && typeof result.searchDirection === 'object' ? result.searchDirection : {},
          feedbackInterpretation: result.feedbackInterpretation || ''
        };

    const normalizedQuestion = result.question && typeof result.question === 'object'
      ? { ...result.question, choices: Array.isArray(result.question.choices) ? [...result.question.choices] : [] }
      : null;
    if (normalizedQuestion?.key === 'reference_conflict') {
      normalizedQuestion.choices = (loadState()?.language || localStorage.getItem(languageKey)) === 'zh'
        ? ['保留原来的需求', '这个产品作为例外保留', '我主要喜欢它的外观', '我主要喜欢它的价格', '我想改变原来的需求', '还不确定']
        : ['Keep my original requirement', 'Keep this product as an exception', 'I mainly like its look', 'I mainly like its price', 'Change my original requirement', 'Not sure'];
    }

    const recommendationResult = {
      method: 'jev_backend_v1',
      nextAction: result.nextAction || decisionState.nextAction || 'ask_more',
      answerLevel: decisionState.answerLevel,
      question: normalizedQuestion,
      receivedAt: new Date().toISOString(),
      products: products.map((product) => ({
        title: product.title,
        url: product.url,
        label: product.label,
        explanation: product.explanation,
        score: product.score
      }))
    };

    const currentState = loadState();
    const currentV2 = buildRufusV2State(currentState);
    saveState({
      rufusV2: {
        ...currentV2,
        decision: decisionState,
        journey: {
          ...currentV2.journey,
          lastShownProducts: products.map((product) => product.title).filter(Boolean)
        }
      },
      recommendationResult,
      recommendationPresentation: {
        method: 'jev_backend_v1',
        products
      }
    });
    renderAdaptiveTurn({ ...result, question: normalizedQuestion });
    document.dispatchEvent(new CustomEvent('rf:assistant:jev-result', {
      detail: { recommendationResult }
    }));
  };

  const sendHandoffPayload = async (reason, payload) => {
    if (!jevSyncReasons.has(reason) || !payload) return;
    const stage1State = loadState().enq10qaStage1;
    if (!stage1State?.completedAt) return;
    const requestSequence = ++jevRequestSequence;
    const state = loadState();
    const needValues = Object.values(payload.needs?.priorities || {}).filter(Boolean);
    const hasEnoughConversationNeed = Boolean(payload.needs?.room && (needValues.length || payload.needs?.customerNotes));
    const shouldLoadConversationScope = stage1State?.phase !== 'type_guide'
      && runtimeCandidatePool.source === 'conversation_global'
      && !expandedCandidatePoolLoaded
      && hasEnoughConversationNeed
      && (reason === 'first_answer' || reason === 'prompt_accepted' || reason === 'recommendations_updated' || reason === 'return_visit');

    if (shouldLoadConversationScope) {
      await loadExpandedCandidatePool();
      if (requestSequence !== jevRequestSequence) return;
      const latestState = loadState();
      const latestInput = latestState.recommendationInput || {};
      saveState({
        recommendationInput: {
          ...latestInput,
          candidatePool: {
            source: runtimeCandidatePool.source || 'conversation_global',
            productCount: runtimeCandidatePool.products.length
          }
        }
      });
    }

    fetch(jevSyncPath, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildJevRequestPayload(payload)),
      credentials: 'same-origin',
      keepalive: true
    })
      .then((response) => response.ok ? response.json() : null)
      .then((result) => {
        if (requestSequence !== jevRequestSequence) return;
        applyJevDecision(result);
      })
      .catch(() => {});
  };

  document.addEventListener('rf:assistant:handoff-ready', (event) => {
    const reason = event.detail?.reason || '';
    const payload = event.detail?.payload;
    sendHandoffPayload(reason, payload);
  });

  const recordSubmittedEnquiry = (detail = {}) => {
    const current = loadState();
    if (detail.requestId && current.lastEnquiryRequestId === detail.requestId) return;

    saveState({
      enquirySubmitCount: (current.enquirySubmitCount || 0) + 1,
      lastEnquirySubmittedAt: detail.submittedAt || new Date().toISOString(),
      lastEnquiryProducts: Array.isArray(detail.products) ? detail.products : [],
      lastEnquiryColours: Array.isArray(detail.colours) ? detail.colours : [],
      lastEnquirySource: detail.source || '',
      lastEnquiryRequestId: detail.requestId || ''
    });

    try {
      sessionStorage.removeItem(successContextKey);
    } catch (_error) {
    }

    refreshNeedProfile();
    window.setTimeout(() => refreshHandoffPayload('enquiry_submitted'), 50);
  };

  document.addEventListener('rf:enquiry:submitted', (event) => {
    recordSubmittedEnquiry(event.detail || {});
  });

  const syncPostedEnquirySuccess = () => {
    if (!document.querySelector('[data-tcvc-enquiry-success]')) return;
    try {
      const detail = JSON.parse(sessionStorage.getItem(successContextKey) || 'null');
      if (detail) recordSubmittedEnquiry(detail);
    } catch (_error) {
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPostedEnquirySuccess, { once: true });
  } else {
    syncPostedEnquirySuccess();
  }

  const localDateKey = (value) => {
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(date);
  };

  const maybeSyncReturnVisit = () => {
    if (!isReturningVisitor) return;
    const state = loadState();
    const today = localDateKey(new Date());
    const firstSeenDate = localDateKey(state.firstSeenAt || localStorage.getItem(firstSeenKey));
    const hadPriorEngagement = Boolean(
      state.room ||
      state.acceptedDecisionAction ||
      state.conversationAction ||
      state.lastRecommendationAction ||
      state.handoffPayload
    );
    if (!today || !firstSeenDate || firstSeenDate === today || !hadPriorEngagement) return;
    if (state.lastReturnSyncDate === today) return;
    saveState({ lastReturnSyncDate: today });
    refreshHandoffPayload('return_visit');
  };

  const refreshCandidateRanking = () => {
    const state = loadState();
    const input = state.recommendationInput || {};
    const products = Array.isArray(runtimeCandidatePool.products) ? runtimeCandidatePool.products : [];
    const explicit = input.explicitNeeds || {};
    const priorities = explicit.priorities || {};
    const priorityText = Object.values(priorities).join(' ').toLowerCase();
    const freeTextQuery = String(explicit.customerNotes || explicit.freeText || '').toLowerCase();

    const ranked = products.map((product) => {
      const reasons = [];
      const exclusions = [];
      let score = 0;
      const water = String(product.waterResistance || '').toLowerCase();
      const priceBand = String(product.priceBand || '').toLowerCase();
      const flooringType = String(product.flooringType || '').toLowerCase();
      const pattern = String(product.pattern || '').toLowerCase();
      const acRating = String(product.acRating || '').toLowerCase();

      if (priorityText.includes('water') || priorityText.includes('防水')) {
        if (water.includes('waterproof')) {
          score += 5;
          reasons.push('waterproof_match');
        } else if (water.includes('water resistant')) {
          score += 3;
          reasons.push('water_resistance_match');
        }
      }

      if (priorityText.includes('lower budget') || priorityText.includes('预算低一些')) {
        if (priceBand === '$') {
          score += 4;
          reasons.push('lower_budget_price_band');
        } else if (priceBand === '$$') {
          score += 3;
          reasons.push('lower_budget_price_band');
        } else if (priceBand === '$$$') {
          score += 1;
          reasons.push('mid_price_band');
        }
      }

      if (priorityText.includes('best value') || priorityText.includes('性价比')) {
        if (priceBand === '$$' || priceBand === '$$$') {
          score += 2;
          reasons.push('value_candidate');
        }
      }

      if (priorityText.includes('timber') || priorityText.includes('木')) {
        const haystack = `${product.title} ${product.pattern}`.toLowerCase();
        if (haystack.includes('timber') || haystack.includes('hardwood')) {
          score += 4;
          reasons.push('timber_match');
        }
      }

      if (freeTextQuery) {
        if ((freeTextQuery.includes('spc') || freeTextQuery.includes('hybrid')) && flooringType.includes('hybrid')) {
          score += 6;
          reasons.push('free_text_type_match');
        }
        if ((freeTextQuery.includes('timber') || freeTextQuery.includes('hardwood') || freeTextQuery.includes('wood')) && (flooringType.includes('timber') || flooringType.includes('hardwood'))) {
          score += 6;
          reasons.push('free_text_type_match');
        }
        if ((freeTextQuery.includes('water') || freeTextQuery.includes('waterproof')) && water.includes('waterproof')) {
          score += 5;
          reasons.push('waterproof_match');
        }
        if ((freeTextQuery.includes('cheap') || freeTextQuery.includes('budget') || freeTextQuery.includes('value')) && (priceBand === '$' || priceBand === '$$')) {
          score += priceBand === '$' ? 5 : 3;
          reasons.push('lower_budget_price_band');
        }
      }

      return {
        ...product,
        eligible: exclusions.length === 0,
        score,
        reasons,
        exclusions
      };
    });

    const shortlist = ranked
      .filter((product) => product.eligible)
      .sort((a, b) => b.score - a.score || a.title.localeCompare(b.title))
      .slice(0, 6);

    const language = state.language === 'zh' ? 'zh' : 'en';
    const presentationCopy = language === 'zh'
      ? {
          bestFit: '综合匹配',
          goodOption: '合适选择',
          water: '更适合防水需求',
          timber: '更偏天然木质感',
          budget: '预算友好选择',
          value: '性价比选择',
          waterproof: '它的防水等级符合你对防水性能的重点需求。',
          waterResistant: '它的耐水等级符合你目前的需求。',
          timberMatch: '从目前的产品资料来看，它更接近你想要的木质感。',
          lowerBudget: '它所在的价格区间更接近你希望控制的预算。',
          valueCandidate: '它处于中等价格区间，更符合你对性价比的要求。',
          suitable: '根据你目前的筛选条件和偏好，它仍然是一个合适的选择。'
        }
      : {
          bestFit: 'Best fit',
          goodOption: 'Good option',
          water: 'Strong water-resistance fit',
          timber: 'Stronger timber feel',
          budget: 'Budget-friendly option',
          value: 'Good value option',
          waterproof: 'Its waterproof rating matches your water-resistance priority.',
          waterResistant: 'Its water-resistance rating matches your stated priority.',
          timberMatch: 'Its product information points to a stronger timber fit.',
          lowerBudget: 'Its price band is closer to the lower-budget options you asked for.',
          valueCandidate: 'It sits in a mid-range price band and better matches your value focus.',
          suitable: 'It remains a suitable option after your current filters and preferences are applied.'
        };

    const presentation = shortlist.map((product, index) => {
      const reasonSet = new Set(product.reasons || []);
      let label = index === 0 ? presentationCopy.bestFit : presentationCopy.goodOption;
      if (reasonSet.has('waterproof_match')) label = presentationCopy.water;
      if (reasonSet.has('timber_match')) label = presentationCopy.timber;
      if (reasonSet.has('lower_budget_price_band')) label = presentationCopy.budget;
      if (reasonSet.has('value_candidate') && index !== 0) label = presentationCopy.value;

      const explanationParts = [];
      if (reasonSet.has('waterproof_match')) explanationParts.push(presentationCopy.waterproof);
      else if (reasonSet.has('water_resistance_match')) explanationParts.push(presentationCopy.waterResistant);
      if (reasonSet.has('timber_match')) explanationParts.push(presentationCopy.timberMatch);
      if (reasonSet.has('lower_budget_price_band')) explanationParts.push(presentationCopy.lowerBudget);
      if (reasonSet.has('value_candidate')) explanationParts.push(presentationCopy.valueCandidate);
      if (!explanationParts.length) explanationParts.push(presentationCopy.suitable);

      return {
        title: product.title,
        url: product.url,
        vendor: product.vendor,
        flooringType: product.flooringType,
        acRating: product.acRating,
        boardSizes: product.boardSizes,
        label,
        explanation: explanationParts.slice(0, 2).join(' '),
        publicPriceText: product.publicPriceText,
        priceVisibility: product.priceVisibility,
        pattern: product.pattern,
        waterResistance: product.waterResistance,
        thickness: product.thickness,
        colours: product.colours
      };
    });

    saveState({
      candidateRanking: {
        method: 'deterministic_v1',
        shortlist,
        evaluatedCount: ranked.length,
        eligibleCount: ranked.filter((product) => product.eligible).length
      },
      recommendationPresentation: {
        method: 'deterministic_v1',
        products: presentation
      }
    });
    refreshHandoffPayload('recommendations_updated');
  };

  refreshNeedProfile();
  refreshRecommendationInput();
  window.setTimeout(maybeSyncReturnVisit, 0);

  const promptCopy = {
    en: {
      offer_help: 'Need a hand narrowing these options down?',
      type_help: 'You have been looking across different flooring types. Want help choosing the right type?',
      compare_help: 'Want me to help compare the products you selected?',
      budget_help: 'Want help finding options that better fit your budget?',
      high_intent_support: 'Ready for the next step? I can help with your enquiry or quote.',
      accept: 'Yes, help me',
      later: 'Not now'
    },
    zh: {
      offer_help: '要不要我帮你把这些选择再缩小一点？',
      type_help: '你看了几种不同类型的地板，要不要我帮你判断哪一种更适合？',
      compare_help: '要不要我帮你比较刚才选中的产品？',
      budget_help: '要不要我按你的预算帮你筛选更合适的选择？',
      high_intent_support: '如果你准备继续，我可以帮你处理 enquiry 或 quote。',
      accept: '帮我看看',
      later: '暂时不用'
    }
  };

  const conversationCopy = {
    en: {
      title: 'Rufus — online flooring assistant',
      compare_help: {
        message: 'You selected products to compare. What matters most to you?',
        choices: ['Durability', 'Natural timber feel', 'Water resistance', 'Value']
      },
      type_help: {
        message: 'You have been looking across different flooring types. What is most important for your home?',
        choices: ['Water resistance', 'Natural timber', 'Easy care', 'Value']
      },
      budget_help: {
        message: 'I can help you work out a rough price range based on the products and your project. The final price can vary depending on product choice, area and installation conditions, so our team will double-check it for a more accurate quote.',
        choices: ['Lower budget', 'Best value', 'Better quality', 'Not sure']
      },
      offer_help: {
        message: 'Tell me what matters most and I will help narrow the options.',
        choices: ['Durability', 'Easy care', 'Timber look', 'Value']
      },
      high_intent_support: {
        message: 'I can help you prepare the next step for an enquiry or quote.',
        choices: ['Get a quote', 'Ask about a product', 'Compare options', 'Keep browsing']
      },
      label: 'Or tell me in your own words',
      send: 'Send'
    },
    zh: {
      title: 'Rufus 在线地板助手',
      compare_help: {
        message: '你已经选了几款产品比较。你最在意哪一点？',
        choices: ['耐用性', '天然木质感', '防水性能', '性价比']
      },
      type_help: {
        message: '你看了几种不同类型的地板。对你家来说最重要的是什么？',
        choices: ['防水', '天然木材', '容易打理', '性价比']
      },
      budget_help: {
        message: '我可以先根据产品和你的项目情况帮你估一个大概的价格范围。实际价格还会受到产品选择、面积和安装条件等因素影响，我们的工作人员会再帮你确认，给你更准确的报价。',
        choices: ['预算低一些', '性价比', '更高品质', '还不确定']
      },
      offer_help: {
        message: '告诉我你最在意什么，我来帮你缩小选择范围。',
        choices: ['耐用', '容易打理', '木质感', '性价比']
      },
      high_intent_support: {
        message: '我可以帮你准备下一步 enquiry 或 quote。',
        choices: ['获取报价', '询问产品', '比较选择', '继续浏览']
      },
      label: '也可以直接告诉我你的想法',
      send: '发送'
    }
  };

  const copy = {
    en: {
      kicker: 'Rufus · Online flooring assistant',
      title: 'Hi! I can help you find the right flooring.',
      questionKicker: 'Stage 1 · Find the right flooring type',
      freeLabel: 'Anything else you would like JEV to know? You can add details at any step.',
      continue: 'Continue'
    },
    zh: {
      kicker: 'Rufus · 在线地板助手',
      title: '您好，我可以帮您一起挑选合适的地板。',
      questionKicker: '第一阶段 · 先找到合适的地板类型',
      freeLabel: '还有什么想告诉 JEV 的？任何一步都可以补充文字。',
      continue: '继续'
    }
  };

  const STAGE1_QUESTIONS = {
    en: [
      { key: 'room', title: 'Where will the flooring be installed?', hint: 'Choose all that apply, or choose Whole home.', multi: true, exclusive: ['whole_home', 'not_sure'], options: [['kitchen','Kitchen'],['living','Living room'],['bedroom','Bedroom'],['whole_home','Whole home'],['other','Other'],['not_sure','Not sure']] },
      { key: 'property_use', title: 'Is this for your own home or a rental property?', hint: '', multi: false, options: [['own_home','My own home'],['rental','Rental property'],['not_sure','Not sure']] },
      { key: 'water', title: 'How important is water resistance?', hint: '', multi: false, options: [['must_have','Must have'],['important','Important'],['low','Not a priority'],['not_sure','Not sure']] },
      { key: 'priority', title: 'What matters most?', hint: 'Choose the single biggest priority for this first pass.', multi: false, options: [['value','Best value'],['natural','Natural timber'],['maintenance','Easy maintenance'],['durability','Durability'],['comfort','Comfort / quiet'],['not_sure','Not sure']] },
      { key: 'look', title: 'What look or material do you prefer?', hint: '', multi: false, options: [['real_timber','Real timber'],['timber_look','Timber look'],['no_preference','No preference'],['not_sure','Not sure']] },
      { key: 'special', title: 'Any special requirements?', hint: 'Choose any that apply, or choose None / Not sure.', multi: true, exclusive: ['none', 'not_sure'], options: [['pets','Pets'],['children','Children'],['traffic','High traffic'],['quiet','Quiet underfoot'],['none','None'],['not_sure','Not sure']] }
    ],
    zh: [
      { key: 'room', title: '准备铺在哪里？', hint: '可以多选；如果是全屋，请选择“全屋”。', multi: true, exclusive: ['whole_home', 'not_sure'], options: [['kitchen','厨房'],['living','客厅'],['bedroom','卧室'],['whole_home','全屋'],['other','其他'],['not_sure','还不确定']] },
      { key: 'property_use', title: '这是自住房还是出租房？', hint: '', multi: false, options: [['own_home','自住房'],['rental','出租房'],['not_sure','还不确定']] },
      { key: 'water', title: '防水性能对你有多重要？', hint: '', multi: false, options: [['must_have','必须防水'],['important','比较重要'],['low','不是重点'],['not_sure','还不确定']] },
      { key: 'priority', title: '你目前最看重哪一点？', hint: '第一轮先选一个最主要的重点。', multi: false, options: [['value','性价比'],['natural','天然木材'],['maintenance','容易打理'],['durability','耐用'],['comfort','脚感 / 安静'],['not_sure','还不确定']] },
      { key: 'look', title: '你偏好什么外观或材料？', hint: '', multi: false, options: [['real_timber','真正木材'],['timber_look','木纹效果'],['no_preference','没有特别偏好'],['not_sure','还不确定']] },
      { key: 'special', title: '还有特别要求吗？', hint: '可以多选；没有或不确定也可以直接选择。', multi: true, exclusive: ['none', 'not_sure'], options: [['pets','宠物'],['children','小孩'],['traffic','高使用强度'],['quiet','脚感安静'],['none','没有'],['not_sure','还不确定']] }
    ]
  };

  let currentPromptAction = '';

  function normaliseRoomList(value) {
    if (Array.isArray(value)) return value.map((item) => String(item || '').trim()).filter(Boolean);
    return String(value || '').split(',').map((item) => item.trim()).filter(Boolean);
  }

  const createEmptyStage1Draft = () => ({
    room: [],
    property_use: [],
    water: [],
    priority: [],
    look: [],
    special: [],
    freeText: ''
  });
  let stage1Step = 0;
  let stage1Draft = (() => {
    const saved = loadState().enq10qaDraft;
    return saved && typeof saved === 'object'
      ? { ...createEmptyStage1Draft(), ...saved }
      : createEmptyStage1Draft();
  })();

  const stage1QuestionSet = (language) => STAGE1_QUESTIONS[language === 'zh' ? 'zh' : 'en'];

  const stage1Label = (language, key, value) => {
    const question = stage1QuestionSet(language).find((item) => item.key === key);
    return question?.options.find((item) => item[0] === value)?.[1] || value;
  };

  const stage1Labels = (language, key, values) => (Array.isArray(values) ? values : [values])
    .filter(Boolean)
    .map((value) => stage1Label(language, key, value));

  const saveStage1DraftLocal = () => {
    stage1Draft.freeText = freeText?.value.trim() || stage1Draft.freeText || '';
    saveState({ enq10qaDraft: stage1Draft });
  };

  const renderStage1Review = (language) => {
    if (!stage1Review) return;
    const questions = stage1QuestionSet(language);
    const rows = questions.slice(0, stage1Step).filter((question) => (stage1Draft[question.key] || []).length);
    stage1Review.replaceChildren();
    rows.forEach((question, index) => {
      const row = document.createElement('div');
      row.className = 'rf-jev__stage1-review-row';
      const key = document.createElement('strong');
      key.textContent = question.title.replace(/\?$/, '');
      const value = document.createElement('span');
      value.textContent = stage1Labels(language, question.key, stage1Draft[question.key]).join(', ');
      const edit = document.createElement('button');
      edit.type = 'button';
      edit.className = 'rf-jev__stage1-review-edit';
      edit.dataset.rfStage1Edit = String(index);
      edit.textContent = language === 'zh' ? '修改' : 'Change';
      row.append(key, value, edit);
      stage1Review.append(row);
    });
    stage1Review.hidden = !rows.length;
  };

  const collectStage1Step = () => {
    const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    const question = stage1QuestionSet(language)[stage1Step];
    if (!question || !stage1Options) return false;
    const values = Array.from(stage1Options.querySelectorAll('input:checked')).map((input) => input.value);
    if (!values.length) {
      stage1Error.textContent = language === 'zh' ? '请选择一个答案再继续。' : 'Please choose an answer to continue.';
      stage1Error.hidden = false;
      stage1Options.querySelector('input')?.focus();
      return false;
    }
    stage1Draft[question.key] = values;
    stage1Draft.freeText = freeText?.value.trim() || '';
    saveStage1DraftLocal();
    stage1Error.hidden = true;
    return true;
  };

  const renderStage1Step = (language, requestedStep = stage1Step) => {
    const questions = stage1QuestionSet(language);
    stage1Step = Math.max(0, Math.min(Number(requestedStep) || 0, questions.length - 1));
    const question = questions[stage1Step];
    updateUtilityLabels(language);
    questionKicker.textContent = copy[language]?.questionKicker || copy.en.questionKicker;
    stage1Counter.textContent = language === 'zh'
      ? `第 ${stage1Step + 1} / ${questions.length} 题`
      : `Question ${stage1Step + 1} of ${questions.length}`;
    questionTitle.textContent = question.title;
    stage1Hint.textContent = question.hint || '';
    stage1Hint.hidden = !question.hint;
    stage1Progress.style.width = `${((stage1Step + 1) / questions.length) * 100}%`;
    freeLabel.textContent = copy[language]?.freeLabel || copy.en.freeLabel;
    freeText.value = stage1Draft.freeText || '';
    stage1Options.replaceChildren();
    question.options.forEach(([value, label]) => {
      const wrapper = document.createElement('label');
      const input = document.createElement('input');
      input.type = question.multi ? 'checkbox' : 'radio';
      input.name = 'rf-stage1-' + question.key;
      input.value = value;
      input.checked = (stage1Draft[question.key] || []).includes(value);
      const text = document.createElement('span');
      text.textContent = label;
      wrapper.append(input, text);
      stage1Options.append(wrapper);
    });
    stage1Back.disabled = stage1Step === 0;
    stage1Next.textContent = stage1Step === questions.length - 1
      ? (language === 'zh' ? '查看类型建议' : 'See type recommendation')
      : (language === 'zh' ? '下一题' : 'Next');
    stage1Error.hidden = true;
    renderStage1Review(language);
    languageStep.hidden = true;
    questionStep.hidden = false;
    conversationMain.hidden = true;
  };

  const STAGE1_TYPES = ['hybrid', 'laminate', 'vinyl', 'hardwood'];
  const STAGE1_SCORES = {
    room: {
      kitchen: { hybrid: 3, vinyl: 3, laminate: 1, hardwood: -1 },
      living: { hardwood: 2, hybrid: 1, laminate: 1, vinyl: 0 },
      bedroom: { hardwood: 2, laminate: 1, hybrid: 1, vinyl: 0 },
      whole_home: { hybrid: 3, hardwood: 2, laminate: 2, vinyl: 1 },
      other: {}, not_sure: {}
    },
    property_use: {
      own_home: {},
      rental: { laminate: 3, vinyl: 3, hybrid: 2, hardwood: -1 },
      not_sure: {}
    },
    water: {
      must_have: { hybrid: 4, vinyl: 4, laminate: 1, hardwood: -2 },
      important: { hybrid: 3, vinyl: 3, laminate: 2, hardwood: 0 },
      low: { hardwood: 1, laminate: 1 },
      not_sure: {}
    },
    priority: {
      value: { laminate: 4, vinyl: 3, hybrid: 2, hardwood: -1 },
      natural: { hardwood: 5, hybrid: 0, laminate: -2, vinyl: -2 },
      maintenance: { vinyl: 4, hybrid: 3, laminate: 3, hardwood: 0 },
      durability: { hybrid: 3, laminate: 3, hardwood: 2, vinyl: 2 },
      comfort: { hardwood: 3, vinyl: 1, hybrid: 1, laminate: 0 },
      not_sure: {}
    },
    look: {
      real_timber: { hardwood: 5, hybrid: -1, laminate: -2, vinyl: -2 },
      timber_look: { hybrid: 3, laminate: 3, vinyl: 2, hardwood: 1 },
      no_preference: {},
      not_sure: {}
    },
    special: {
      pets: { hybrid: 3, vinyl: 3, laminate: 2, hardwood: 0 },
      children: { hybrid: 3, vinyl: 2, laminate: 2, hardwood: 1 },
      traffic: { hybrid: 3, laminate: 3, vinyl: 2, hardwood: 1 },
      quiet: { hardwood: 3, vinyl: 1, hybrid: 1, laminate: 0 },
      none: {}, not_sure: {}
    }
  };

  const STAGE1_TYPE_META = {
    hybrid: { en: 'Hybrid Flooring', zh: 'Hybrid 地板', url: '/collections/hybrid-flooring' },
    laminate: { en: 'Laminate Flooring', zh: 'Laminate 地板', url: '/collections/laminate-flooring' },
    vinyl: { en: 'Vinyl Plank Flooring', zh: 'Vinyl Plank 地板', url: '/collections/vinyl-plank-flooring' },
    hardwood: { en: 'Hardwood Flooring', zh: 'Hardwood 木地板', url: '/collections/hardwood-flooring' }
  };

  const calculateStage1Guide = (answers) => {
    const scores = Object.fromEntries(STAGE1_TYPES.map((type) => [type, 0]));
    Object.entries(answers || {}).forEach(([group, values]) => {
      if (!STAGE1_SCORES[group]) return;
      (Array.isArray(values) ? values : [values]).filter(Boolean).forEach((value) => {
        STAGE1_TYPES.forEach((type) => {
          scores[type] += STAGE1_SCORES[group]?.[value]?.[type] || 0;
        });
      });
    });
    const ranked = STAGE1_TYPES.slice().sort((a, b) => scores[b] - scores[a]);
    return { ranked, scores, createdAt: new Date().toISOString() };
  };

  const stage1ReasonText = (language, type, answers) => {
    const reasons = [];
    const water = answers.water || [];
    const priority = answers.priority || [];
    const look = answers.look || [];
    const special = answers.special || [];
    if ((water.includes('must_have') || water.includes('important')) && ['hybrid','vinyl'].includes(type)) {
      reasons.push(language === 'zh' ? '防水需求匹配较强' : 'stronger fit for your water-resistance needs');
    }
    if (priority.includes('value') && ['laminate','vinyl','hybrid'].includes(type)) {
      reasons.push(language === 'zh' ? '更符合性价比方向' : 'fits your value priority');
    }
    if ((priority.includes('natural') || look.includes('real_timber')) && type === 'hardwood') {
      reasons.push(language === 'zh' ? '最符合真正木材的偏好' : 'best matches your real-timber preference');
    }
    if ((priority.includes('maintenance') || special.includes('pets') || special.includes('traffic')) && ['hybrid','laminate','vinyl'].includes(type)) {
      reasons.push(language === 'zh' ? '更适合容易打理或高使用强度' : 'better suited to easy care or heavier use');
    }
    if (!reasons.length) {
      reasons.push(language === 'zh' ? '在目前六项答案里综合匹配较好' : 'a balanced match across your six core answers');
    }
    return reasons.slice(0, 2).join(language === 'zh' ? '；' : '; ');
  };

  const renderStage1AnswerSummary = (stage1State) => {
    if (!answerSummary) return;
    const language = stage1State.language === 'zh' ? 'zh' : 'en';
    const questions = stage1QuestionSet(language);
    answerSummary.replaceChildren();

    const details = document.createElement('details');
    details.className = 'rf-jev__answer-summary-details';

    const summary = document.createElement('summary');
    summary.className = 'rf-jev__answer-summary-toggle';
    summary.textContent = language === 'zh'
      ? `查看第一阶段回答（${questions.length}）`
      : `Review Stage 1 answers (${questions.length})`;

    const content = document.createElement('div');
    content.className = 'rf-jev__answer-summary-content';

    const list = document.createElement('div');
    list.className = 'rf-jev__answer-summary-list';
    questions.forEach((question, index) => {
      const row = document.createElement('div');
      row.className = 'rf-jev__answer-summary-row';
      const key = document.createElement('span');
      key.className = 'rf-jev__answer-summary-key';
      key.textContent = question.title.replace(/\?$/, '');
      const value = document.createElement('span');
      value.className = 'rf-jev__answer-summary-value';
      value.textContent = stage1Labels(language, question.key, stage1State.answers?.[question.key] || []).join(', ');
      const change = document.createElement('button');
      change.type = 'button';
      change.className = 'rf-jev__answer-summary-change';
      change.dataset.rfStage1ResultEdit = String(index);
      change.textContent = language === 'zh' ? '修改' : 'Change';
      row.append(key, value, change);
      list.append(row);
    });
    content.append(list);

    if (stage1State.freeText) {
      const note = document.createElement('p');
      note.className = 'rf-jev__answer-summary-note';
      note.textContent = (language === 'zh' ? '补充说明：' : 'Extra detail: ') + stage1State.freeText;
      content.append(note);
    }

    details.append(summary, content);
    answerSummary.append(details);
    answerSummary.hidden = false;
  };

  const renderStage1Result = (stage1State) => {
    if (!stage1State?.answers) return;
    const language = stage1State.language === 'zh' ? 'zh' : 'en';
    const guide = stage1State.typeGuide || calculateStage1Guide(stage1State.answers);

    languageStep.hidden = true;
    questionStep.hidden = true;
    conversationMain.hidden = false;
    conversation.hidden = false;
    launcher.hidden = true;
    conversationTitle.textContent = language === 'zh'
      ? 'Rufus — 第一阶段类型建议'
      : 'Rufus — Stage 1 type guide';
    conversationBody.textContent = language === 'zh'
      ? '先根据六个核心问题给你一个地板类型方向。你补充的文字也已经和这一轮资料一起交给 JEV。'
      : 'Here is the flooring-type direction from the six core questions. Your written details were included in the same JEV batch.';

    renderStage1AnswerSummary(stage1State);
    recommendations.replaceChildren();
    const wrap = document.createElement('div');
    wrap.className = 'rf-jev__type-guide';

    guide.ranked.slice(0, 4).forEach((type, index) => {
      const meta = STAGE1_TYPE_META[type];
      const card = document.createElement('article');
      card.className = 'rf-jev__type-card' + (index === 0 ? ' is-primary' : '');

      const rank = document.createElement('span');
      rank.className = 'rf-jev__type-rank';
      rank.textContent = index === 0
        ? (language === 'zh' ? '优先建议' : 'Primary direction')
        : (language === 'zh' ? `第 ${index + 1} 选择` : `#${index + 1} option`);

      const title = document.createElement('h3');
      title.textContent = meta[language] || meta.en;

      const detail = document.createElement('p');
      detail.textContent = stage1ReasonText(language, type, stage1State.answers);

      const link = document.createElement('a');
      link.className = 'button button--secondary';
      link.href = meta.url;
      link.textContent = language === 'zh' ? '查看这个类型' : 'View this flooring type';

      card.append(rank, title, detail, link);
      wrap.append(card);
    });

    recommendations.append(wrap);
    recommendations.hidden = false;
    recommendationActions.replaceChildren();

    const nextNote = document.createElement('p');
    nextNote.className = 'rf-jev__recommendation-copy';
    nextNote.textContent = language === 'zh'
      ? '第一阶段到这里完成。下一阶段我们再增加更具体的问题，把范围缩到这个类型里的产品。'
      : 'Stage 1 is complete. The next stage can ask deeper questions to narrow this type down to specific products.';
    recommendationActions.append(nextNote);
    recommendationActions.hidden = false;

    conversationChoices.replaceChildren();
    conversationLabel.textContent = '';
    conversationText.value = '';
    conversationText.hidden = true;
    conversationSend.hidden = true;
    updateUtilityLabels(language);
  };

  const completeStage1 = () => {
    const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    stage1Draft.freeText = freeText?.value.trim() || '';
    const answers = {
      room: [...stage1Draft.room],
      property_use: [...stage1Draft.property_use],
      water: [...stage1Draft.water],
      priority: [...stage1Draft.priority],
      look: [...stage1Draft.look],
      special: [...stage1Draft.special]
    };
    const typeGuide = calculateStage1Guide(answers);
    const stage1State = {
      version: 1,
      phase: 'type_guide',
      language,
      answers,
      freeText: stage1Draft.freeText,
      typeGuide,
      completedAt: new Date().toISOString()
    };

    const roomLabels = stage1Labels(language, 'room', answers.room);
    const current = loadState();
    const currentV2 = buildRufusV2State(current);
    const needProfile = {
      explicit: {
        room: roomLabels.join(', '),
        rooms: roomLabels,
        priorities: {
          property_use: answers.property_use.join(','),
          water: answers.water.join(','),
          main: answers.priority.join(','),
          look: answers.look.join(','),
          special: answers.special.join(',')
        },
        freeText: stage1Draft.freeText
      },
      updatedAt: new Date().toISOString()
    };

    saveState({
      enq10qaStage1: stage1State,
      enq10qaDraft: null,
      language,
      room: roomLabels.join(', '),
      rooms: roomLabels,
      freeText: stage1Draft.freeText,
      needProfile,
      rufusV2: {
        ...currentV2,
        need: {
          ...currentV2.need,
          room: roomLabels,
          propertyUse: answers.property_use[0] || null,
          waterProtection: answers.water[0] || null,
          priorities: answers.priority,
          style: answers.look,
          special: answers.special,
          freeText: stage1Draft.freeText
        },
        requirementStatus: {
          room: answers.room.includes('not_sure') ? 'tentative' : 'confirmed',
          propertyUse: answers.property_use.includes('not_sure') ? 'tentative' : 'confirmed',
          waterProtection: answers.water.includes('not_sure') ? 'tentative' : 'confirmed',
          priority: answers.priority.includes('not_sure') ? 'tentative' : 'confirmed',
          style: answers.look.includes('not_sure') ? 'tentative' : 'confirmed',
          special: answers.special.includes('not_sure') ? 'tentative' : 'confirmed'
        }
      }
    });

    refreshRecommendationInput({ rank: false });
    renderStage1Result(stage1State);
    refreshHandoffPayload('first_answer');
  };

  const ensureDecisionAssumptions = () => buildRufusV2State(loadState());

  const renderAnswerSummary = () => {
    if (!answerSummary) return;
    const state = loadState();
    const language = state.language === 'zh' || localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    const explicit = state.needProfile?.explicit || {};
    const v2 = ensureDecisionAssumptions();
    const statuses = v2.requirementStatus || {};
    const rooms = normaliseRoomList(explicit.rooms?.length ? explicit.rooms : (explicit.room || state.rooms || state.room));
    const priorities = Object.values(explicit.priorities || {}).map((value) => String(value || '').trim()).filter(Boolean);
    const budget = String(v2.need?.budgetPreference || '').trim();
    const water = String(v2.need?.waterProtection || '').trim();
    const petsTraffic = [v2.need?.pets, v2.need?.traffic].filter(Boolean).join(' · ');
    const styles = Array.isArray(v2.need?.style) ? v2.need.style.filter(Boolean) : [];
    const notes = String(explicit.freeText || v2.need?.freeText || '').trim();

    const labelForStatus = (status) => {
      if (!status) return '';
      if (language === 'zh') {
        return status === 'confirmed' ? '已确认'
          : status === 'assumed' ? '未确认'
          : status === 'tentative' ? '未确认'
          : status === 'conflict' ? '需确认'
          : '';
      }
      return status === 'confirmed' ? 'Confirmed'
        : status === 'assumed' ? 'Not confirmed'
        : status === 'tentative' ? 'Not confirmed'
        : status === 'conflict' ? 'Needs review'
        : '';
    };

    const rows = [
      { key: 'room', label: language === 'zh' ? '铺设位置' : 'Room', value: rooms.join(', '), status: rooms.length ? (statuses.room || 'confirmed') : 'unknown' },
      { key: 'water', label: language === 'zh' ? '防水需求' : 'Water protection', value: water, status: statuses.waterProtection || (water ? 'confirmed' : 'unknown') },
      { key: 'priority', label: language === 'zh' ? '重点需求' : 'Priority', value: priorities.join(', '), status: priorities.length ? (statuses.priority || 'confirmed') : 'unknown' },
      { key: 'budget', label: language === 'zh' ? '预算' : 'Budget', value: budget, status: statuses.budget || (budget ? 'confirmed' : 'unknown') },
      { key: 'pets_traffic', label: language === 'zh' ? '宠物 / 使用强度' : 'Pets / traffic', value: petsTraffic, status: statuses.petsTraffic || (petsTraffic ? 'confirmed' : 'unknown') },
      { key: 'style', label: language === 'zh' ? '风格' : 'Style', value: styles.join(', '), status: statuses.style || (styles.length ? 'confirmed' : 'unknown') },
      { key: 'notes', label: language === 'zh' ? '其他说明' : 'Notes', value: notes, status: notes ? 'confirmed' : 'unknown' }
    ];

    answerSummary.replaceChildren();
    const head = document.createElement('div');
    head.className = 'rf-jev__answer-summary-head';
    const title = document.createElement('p');
    title.className = 'rf-jev__answer-summary-title';
    title.textContent = language === 'zh' ? '你的需求' : 'Your flooring requirements';
    head.append(title);

    const list = document.createElement('div');
    list.className = 'rf-jev__answer-summary-list';
    rows.forEach((row) => {
      const item = document.createElement('div');
      item.className = 'rf-jev__answer-summary-row';
      const key = document.createElement('span');
      key.className = 'rf-jev__answer-summary-key';
      key.textContent = row.label;
      const value = document.createElement('span');
      value.className = 'rf-jev__answer-summary-value';
      value.textContent = row.value || (language === 'zh' ? '未填写' : 'Not answered');
      const actionWrap = document.createElement('span');
      const statusText = labelForStatus(row.status);
      if (statusText) {
        const status = document.createElement('span');
        status.className = 'rf-jev__answer-summary-status';
        status.dataset.status = row.status;
        status.textContent = statusText + ' ';
        actionWrap.append(status);
      }
      const change = document.createElement('button');
      change.type = 'button';
      change.className = 'rf-jev__answer-summary-change';
      change.dataset.rfAnswerChange = row.key;
      change.textContent = row.value ? (language === 'zh' ? '修改' : 'Change') : (language === 'zh' ? '添加' : 'Add');
      actionWrap.append(change);
      item.append(key, value, actionWrap);
      list.append(item);
    });

    const note = document.createElement('p');
    note.className = 'rf-jev__answer-summary-note';
    note.textContent = language === 'zh'
      ? '你可以随时修改任何一项。Rufus 暂定的内容不会当作你已经确认的要求。'
      : 'You can change any item at any time. Unconfirmed answers are not treated as confirmed requirements.';
    answerSummary.append(head, list, note);
    answerSummary.hidden = false;
  };

  const openSummaryEditor = (key) => {
    const state = loadState();
    const language = state.language === 'zh' || localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    if (key === 'room') {
      renderQuestion(language);
      const selectedRooms = normaliseRoomList(state.needProfile?.explicit?.rooms?.length
        ? state.needProfile.explicit.rooms
        : (state.needProfile?.explicit?.room || state.rooms || state.room));
      root.querySelectorAll('[data-rf-room]').forEach((button) => {
        button.setAttribute('aria-pressed', selectedRooms.includes(button.dataset.rfRoom) ? 'true' : 'false');
      });
      freeText.value = state.needProfile?.explicit?.freeText || '';
      conversationMain.hidden = true;
      return;
    }

    languageStep.hidden = true;
    questionStep.hidden = true;
    conversationMain.hidden = false;
    conversation.hidden = false;
    launcher.hidden = true;
    recommendations.hidden = true;
    recommendationActions.hidden = true;
    conversationText.value = '';
    conversationSend.disabled = false;

    if (key === 'priority') {
      conversation.dataset.rfAction = 'v2_question';
      conversation.dataset.rfQuestionKey = 'priority';
      conversationBody.textContent = language === 'zh' ? '你现在最看重哪一点？' : 'What matters most to you now?';
      setConversationChoices(language === 'zh'
        ? ['防水', '容易打理', '木质感', '性价比', '还不确定']
        : ['Water resistance', 'Easy care', 'Timber look', 'Value', 'Not sure']);
      conversationLabel.textContent = language === 'zh' ? '也可以直接说明' : 'Or tell me in your own words';
      conversationSend.textContent = language === 'zh' ? '保存' : 'Save';
      return;
    }

    if (key === 'water') {
      conversation.dataset.rfAction = 'v2_question';
      conversation.dataset.rfQuestionKey = 'water_protection';
      conversationBody.textContent = language === 'zh' ? '防水对你来说有多重要？' : 'How important is water protection for this flooring?';
      setConversationChoices(language === 'zh'
        ? ['必须防水', '防泼水即可', '不重要', '还不确定']
        : ['Waterproof required', 'Water resistant is enough', 'Not important', 'Not sure']);
      conversationLabel.textContent = language === 'zh' ? '也可以直接说明' : 'Or tell me in your own words';
      conversationSend.textContent = language === 'zh' ? '保存' : 'Save';
      return;
    }

    if (key === 'pets_traffic') {
      conversation.dataset.rfAction = 'v2_question';
      conversation.dataset.rfQuestionKey = 'pets_traffic';
      conversationBody.textContent = language === 'zh' ? '家里有宠物或高使用强度吗？' : 'Do you have pets or heavy foot traffic?';
      setConversationChoices(language === 'zh'
        ? ['有宠物', '高使用强度', '两者都有', '没有', '还不确定']
        : ['Pets', 'Heavy traffic', 'Both', 'Neither', 'Not sure']);
      conversationLabel.textContent = language === 'zh' ? '也可以直接说明' : 'Or tell me in your own words';
      conversationSend.textContent = language === 'zh' ? '保存' : 'Save';
      return;
    }

    if (key === 'budget') {
      conversation.dataset.rfAction = 'summary_change_budget';
      conversation.dataset.rfQuestionKey = '';
      conversationBody.textContent = language === 'zh' ? '预算方向要改成什么？' : 'How would you like to change the budget direction?';
      setConversationChoices(language === 'zh'
        ? ['预算低一些', '性价比优先', '中等预算', '预算较灵活', '还不确定']
        : ['Lower budget', 'Best value', 'Mid-range', 'Flexible', 'Not sure']);
      conversationLabel.textContent = language === 'zh' ? '也可以输入预算说明' : 'Or enter a budget note';
      conversationSend.textContent = language === 'zh' ? '保存' : 'Save';
      return;
    }

    if (key === 'style') {
      conversation.dataset.rfAction = 'v2_question';
      conversation.dataset.rfQuestionKey = 'style_preference';
      conversationBody.textContent = language === 'zh' ? '你现在偏好什么风格？' : 'What style do you prefer now?';
      setConversationChoices(language === 'zh'
        ? ['浅色自然', '暖木色', '深色', '人字拼', '直板', '还不确定']
        : ['Light natural', 'Warm timber', 'Dark', 'Herringbone', 'Plank', 'Not sure']);
      conversationLabel.textContent = language === 'zh' ? '也可以直接说明' : 'Or describe the style';
      conversationSend.textContent = language === 'zh' ? '保存' : 'Save';
      return;
    }

    conversation.dataset.rfAction = 'summary_change_notes';
    conversation.dataset.rfQuestionKey = '';
    conversationBody.textContent = language === 'zh' ? '更新你的其他需求或说明。' : 'Update your other requirements or notes.';
    setConversationChoices([]);
    conversationLabel.textContent = language === 'zh' ? '你的说明' : 'Your notes';
    conversationText.value = state.needProfile?.explicit?.freeText || '';
    conversationSend.textContent = language === 'zh' ? '保存' : 'Save';
  };

  const openConversation = (action) => {
    if (!conversation) return;
    const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    const t = conversationCopy[language];
    const scenario = t[action] || t.offer_help;
    languageStep.hidden = true;
    questionStep.hidden = true;
    conversationMain.hidden = false;
    conversationTitle.textContent = t.title;
    updateUtilityLabels(language);
    conversationBody.textContent = scenario.message;
    renderAnswerSummary();
    conversationLabel.textContent = t.label;
    conversationSend.textContent = t.send;
    conversationChoices.innerHTML = '';
    scenario.choices.forEach((choice) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--secondary';
      button.textContent = choice;
      button.dataset.rfConversationChoice = choice;
      button.setAttribute('aria-pressed', 'false');
      conversationChoices.appendChild(button);
    });
    conversationText.value = '';
    conversation.dataset.rfAction = action;
    conversation.hidden = false;
    launcher.hidden = true;
    recommendations.hidden = true;
    recommendationActions.hidden = true;
  };

  const openOnboarding = () => {
    if (!conversation) return;
    const saved = localStorage.getItem(languageKey);
    conversationTitle.textContent = saved === 'zh'
      ? 'Rufus — 在线地板助手'
      : 'Rufus — online flooring assistant';
    conversationMain.hidden = true;
    if (saved === 'en' || saved === 'zh') {
      renderQuestion(saved);
    } else {
      const suggested = browserLanguage.toLowerCase().startsWith('zh') ? 'zh' : 'en';
      const t = copy[suggested];
      langKicker.textContent = t.kicker;
      langTitle.textContent = t.title;
      languageStep.hidden = false;
      questionStep.hidden = true;
    }
    conversation.hidden = false;
    launcher.hidden = true;
  };

  const showDecisionPrompt = (action) => {
    if (!decisionPrompt || !promptMessage || !promptAccept || !promptLater) return;
    if (!action || action === 'stay_silent') {
      decisionPrompt.hidden = true;
      return;
    }

    const state = loadState();
    const dismissedUntil = Number(state.promptDismissedUntil || 0);
    if (Date.now() < dismissedUntil) return;

    const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    const text = promptCopy[language];
    promptMessage.textContent = text[action] || text.offer_help;
    promptAccept.textContent = text.accept;
    promptLater.textContent = text.later;
    currentPromptAction = action;
    decisionPrompt.hidden = false;
  };

  document.addEventListener('rf:assistant:decision', (event) => {
    showDecisionPrompt(event.detail?.action || 'stay_silent');
  });

  const currentDecision = observationEnabled ? (loadState().observation?.decision?.action || 'stay_silent') : 'stay_silent';
  showDecisionPrompt(currentDecision);

  const updateUtilityLabels = (language) => {
    root.querySelectorAll('[data-rf-show-options]').forEach((button) => {
      button.textContent = language === 'zh' ? '先看推荐' : 'Show options now';
    });
    root.querySelectorAll('[data-rf-start-over]').forEach((button) => {
      button.textContent = language === 'zh' ? '重新开始' : 'Start over';
    });
  };

  const renderQuestion = (language) => {
    const normalizedLanguage = language === 'zh' ? 'zh' : 'en';
    renderStage1Step(normalizedLanguage, stage1Step);
  };

  stage1Options?.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.checked) return;
    const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    const question = stage1QuestionSet(language)[stage1Step];
    if (!question?.multi) return;
    const exclusive = Array.isArray(question.exclusive) ? question.exclusive : [];
    if (exclusive.includes(input.value)) {
      stage1Options.querySelectorAll('input').forEach((item) => {
        if (item !== input) item.checked = false;
      });
    } else {
      exclusive.forEach((value) => {
        const item = stage1Options.querySelector(`input[value="${value}"]`);
        if (item) item.checked = false;
      });
    }
  });

  stage1Back?.addEventListener('click', () => {
    stage1Draft.freeText = freeText?.value.trim() || stage1Draft.freeText || '';
    if (stage1Step > 0) {
      stage1Step -= 1;
      renderStage1Step(localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en');
    }
  });

  stage1Next?.addEventListener('click', () => {
    if (!collectStage1Step()) return;
    const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    const questions = stage1QuestionSet(language);
    if (stage1Step < questions.length - 1) {
      stage1Step += 1;
      renderStage1Step(language);
      return;
    }
    completeStage1();
  });

  stage1Review?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rf-stage1-edit]');
    if (!button) return;
    const index = Number(button.dataset.rfStage1Edit);
    if (!Number.isInteger(index)) return;
    stage1Draft.freeText = freeText?.value.trim() || stage1Draft.freeText || '';
    stage1Step = index;
    renderStage1Step(localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en');
  });

  root.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rf-stage1-result-edit]');
    if (!button) return;
    const saved = loadState().enq10qaStage1;
    if (!saved?.answers) return;
    stage1Draft = { ...createEmptyStage1Draft(), ...saved.answers, freeText: saved.freeText || '' };
    stage1Step = Number(button.dataset.rfStage1ResultEdit) || 0;
    conversationText.hidden = false;
    conversationSend.hidden = false;
    renderStage1Step(saved.language === 'zh' ? 'zh' : 'en', stage1Step);
  });

  const browserPrefersChinese = browserLanguage.toLowerCase().startsWith('zh');
  const savedLanguage = localStorage.getItem(languageKey);

  if (savedLanguage === 'en' || savedLanguage === 'zh') {
    renderQuestion(savedLanguage);
  } else {
    const suggested = browserPrefersChinese ? 'zh' : 'en';
    const t = copy[suggested];
    langKicker.textContent = t.kicker;
    langTitle.textContent = t.title;

    const enButton = root.querySelector('[data-rf-language="en"]');
    const zhButton = root.querySelector('[data-rf-language="zh"]');
    const choices = root.querySelector('[data-rf-lang-choices]');
    choices.prepend(browserPrefersChinese ? zhButton : enButton);
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-tcv-compare-toggle]')) return;
    const selected = Array.from(document.querySelectorAll('[data-tcv-compare-toggle]:checked'))
      .map((checkbox) => checkbox.closest('[data-tcvc-product-title]')?.getAttribute('data-tcvc-product-title'))
      .filter(Boolean);
    // Compare is operational history only. It must never change Need State or trigger recommendation weighting.
    saveState({ comparedProducts: selected });
  });

  // Product-grid browsing/filtering is deliberately not observed by core Rufus logic.
  // Only explicit conversation input may change needs or trigger a recommendation decision.

  window.RFJevCore = {
    loadState,
    saveState,
    refreshNeedProfile,
    refreshRecommendationInput
  };
  document.dispatchEvent(new CustomEvent('rf:jev:core-ready'));

  answerSummary?.addEventListener('click', (event) => {
    const changeButton = event.target.closest('[data-rf-answer-change]');
    if (!changeButton) return;
    openSummaryEditor(changeButton.dataset.rfAnswerChange || '');
  });

  root.addEventListener('click', (event) => {
    const languageButton = event.target.closest('[data-rf-language]');
    if (languageButton) {
      const language = languageButton.dataset.rfLanguage;
      localStorage.setItem(languageKey, language);
      saveState({ language });
      renderQuestion(language);
      return;
    }
    const roomButton = event.target.closest('[data-rf-room]');
    if (roomButton) {
      event.preventDefault();
      const roomValue = roomButton.dataset.rfRoom || '';
      const isWholeHome = roomValue === 'Whole home' || roomValue === '全屋';
      const isNotSure = roomValue === 'Not sure' || roomValue === '还不确定';
      const wasSelected = roomButton.getAttribute('aria-pressed') === 'true';

      if (isWholeHome || isNotSure) {
        root.querySelectorAll('[data-rf-room]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
        roomButton.setAttribute('aria-pressed', wasSelected ? 'false' : 'true');
      } else {
        root.querySelectorAll('[data-rf-room]').forEach((button) => {
          const value = button.dataset.rfRoom || '';
          if (value === 'Whole home' || value === '全屋' || value === 'Not sure' || value === '还不确定') {
            button.setAttribute('aria-pressed', 'false');
          }
        });
        roomButton.setAttribute('aria-pressed', wasSelected ? 'false' : 'true');
      }
      return;
    }
  });

  const recommendedRows = () => {
    const titles = (loadState().recommendationPresentation?.products || [])
      .map((product) => product.title)
      .filter(Boolean);
    const rows = Array.from(document.querySelectorAll('[data-tcvc-product-title]'));
    const matched = titles
      .map((title) => rows.find((row) => row.getAttribute('data-tcvc-product-title') === title))
      .filter(Boolean);
    return matched.length ? matched : rows;
  };

  const selectRecommendedProducts = (count) => {
    recommendedRows().slice(0, count).forEach((row) => {
      const checkbox = row.querySelector('[data-tcv-compare-toggle]');
      if (checkbox && !checkbox.checked) checkbox.click();
    });
  };

  const openRecommendedEnquiry = () => {
    selectRecommendedProducts(1);
    window.setTimeout(() => {
      const enquiryButton = document.querySelector('[data-tcvc-enquiry-toolbar]');
      if (enquiryButton && !enquiryButton.disabled) enquiryButton.click();
    }, 0);
  };

  const openRecommendedCompare = () => {
    selectRecommendedProducts(2);
    window.setTimeout(() => {
      const compareButton = document.querySelector('[data-tcv-compare-open]');
      if (compareButton && !compareButton.disabled) compareButton.click();
    }, 0);
  };

  promptAccept?.addEventListener('click', () => {
    const state = saveState({
      acceptedDecisionAction: currentPromptAction,
      promptAcceptedAt: new Date().toISOString(),
      promptDismissedUntil: 0
    });
    decisionPrompt.hidden = true;
    openConversation(currentPromptAction);
    refreshHandoffPayload('prompt_accepted');
    document.dispatchEvent(new CustomEvent('rf:assistant:prompt-accepted', {
      detail: {
        action: currentPromptAction,
        customerState: loadState()
      }
    }));
  });

  const dismissPromptForNow = () => {
    saveState({ promptDismissedUntil: Date.now() + (30 * 60 * 1000) });
    decisionPrompt.hidden = true;
  };

  promptLater?.addEventListener('click', dismissPromptForNow);
  promptDismiss?.addEventListener('click', dismissPromptForNow);

  recommendations?.addEventListener('click', (event) => {
    const compareButton = event.target.closest('[data-rf-recommendation-compare]');
    if (compareButton) {
      const title = compareButton.dataset.rfRecommendationCompare || '';
      const row = Array.from(document.querySelectorAll('[data-tcvc-product-title]'))
        .find((item) => item.getAttribute('data-tcvc-product-title') === title);
      const checkbox = row?.querySelector('[data-tcv-compare-toggle]');
      if (checkbox && !checkbox.checked) checkbox.click();
      saveState({ lastRecommendationAction: 'compare', lastRecommendationProduct: title });
      refreshHandoffPayload('recommendation_compare');
      document.dispatchEvent(new CustomEvent('rf:assistant:recommendation-action', {
        detail: { action: 'compare', productTitle: title, customerState: loadState() }
      }));
      return;
    }

    const askPriceButton = event.target.closest('[data-rf-recommendation-ask-price]');
    if (askPriceButton) {
      const title = askPriceButton.dataset.rfRecommendationAskPrice || '';
      const row = Array.from(document.querySelectorAll('[data-tcvc-product-title]'))
        .find((item) => item.getAttribute('data-tcvc-product-title') === title);
      const checkbox = row?.querySelector('[data-tcv-compare-toggle]');
      if (checkbox && !checkbox.checked) checkbox.click();
      const enquiryButton = document.querySelector('[data-tcvc-enquiry-toolbar]');
      if (enquiryButton && !enquiryButton.disabled) enquiryButton.click();
      saveState({ lastRecommendationAction: 'ask_price', lastRecommendationProduct: title });
      refreshHandoffPayload('recommendation_ask_price');
      document.dispatchEvent(new CustomEvent('rf:assistant:recommendation-action', {
        detail: { action: 'ask_price', productTitle: title, customerState: loadState() }
      }));
    }
  });

  recommendationActions?.addEventListener('click', (event) => {
    const refineButton = event.target.closest('[data-rf-recommendation-refine]');
    if (!refineButton) return;
    const refine = refineButton.dataset.rfRecommendationRefine;
    const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    if (refine === 'lower_budget') {
      saveState({
        conversationAction: 'budget_help',
        conversationChoice: language === 'zh' ? '预算低一些' : 'Lower budget'
      });
      conversationBody.textContent = language === 'zh' ? '好的，我已经优先筛选价格更低的选择。' : 'Done — I am prioritising lower-priced options.';
    } else if (refine === 'timber') {
      saveState({
        conversationAction: 'type_help',
        conversationChoice: language === 'zh' ? '天然木材' : 'Natural timber'
      });
      conversationBody.textContent = language === 'zh' ? '好的，我已经优先筛选更接近天然木质感的选择。' : 'Done — I am prioritising options with a stronger timber feel.';
    }
    refreshNeedProfile();
    refreshRecommendationInput();
    window.setTimeout(renderRecommendationCards, 0);
  });

  conversationChoices?.addEventListener('click', (event) => {
    const choiceButton = event.target.closest('[data-rf-conversation-choice]');
    if (!choiceButton) return;
    conversationChoices.querySelectorAll('[data-rf-conversation-choice]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
    choiceButton.setAttribute('aria-pressed', 'true');

    const action = conversation.dataset.rfAction || '';
    const choice = choiceButton.dataset.rfConversationChoice || '';
    const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    const questionKey = conversation.dataset.rfQuestionKey || '';

    // Quick single-choice steps should act immediately. Room stays manual because it can become multi-select.
    if (action === 'v2_feedback' || (action === 'v2_question' && questionKey !== 'room')) {
      window.setTimeout(() => conversationSend?.click(), 0);
      return;
    }

    if (action === 'reference_confirm') {
      const confirmed = choice.toLowerCase() === 'yes' || choice === '是';
      if (confirmed && pendingExplicitReference) {
        const confirmedReference = pendingExplicitReference;
        const similarityMode = confirmedReference.intent === 'find_similar' && confirmedReference.type === 'product';
        if (similarityMode && activateReferenceAsGuide(confirmedReference)) {
          pendingExplicitReference = null;
          conversation.dataset.rfAction = 'reference_similarity_attribute';
          conversation.dataset.rfQuestionKey = '';
          conversationBody.textContent = language === 'zh'
            ? `可以。我会把“${confirmedReference.title}”只当作参考，不会自动改变你之前的需求。你最希望其他产品和它哪一点相似？`
            : `Sure. I will use “${confirmedReference.title}” only as a reference and keep your existing requirements unchanged. What do you most want the alternatives to match?`;
          setConversationChoices(language === 'zh'
            ? ['颜色 / 外观', '木质感', '花纹', '价格', '品牌', '板材尺寸', '整体风格', '还不确定']
            : ['Colour / look', 'Timber feel', 'Pattern', 'Price', 'Brand', 'Board size', 'Overall style', 'Not sure']);
          recommendations.hidden = true;
          recommendationActions.hidden = true;
          conversationLabel.textContent = language === 'zh' ? '也可以直接说明' : 'Or tell me in your own words';
          return;
        }
        if (activateExplicitReference(confirmedReference)) {
          pendingExplicitReference = null;
          conversationBody.textContent = language === 'zh'
            ? `好的，我会只把“${confirmedReference.title}”作为你明确指定的参考范围，并按你已经告诉我的需求来分析。`
            : `Got it. I will use “${confirmedReference.title}” only because you explicitly asked about it, and compare it with the requirements you have told me.`;
          setConversationChoices([]);
          refreshRecommendationInput();
          refreshHandoffPayload('recommendations_updated');
        }
      } else {
        clearExplicitReference();
        conversationBody.textContent = language === 'zh'
          ? '没问题。请打开你要问的产品页面或产品列表，或者把产品名称/链接贴给我。'
          : 'No problem. Please open the product page or collection/product list you mean, or paste the product name or link here.';
        setConversationChoices([]);
      }
      return;
    }

    if (action === 'reference_similarity_attribute') {
      const state = loadState();
      const currentV2 = buildRufusV2State(state);
      const mapAttribute = (value) => {
        const key = String(value || '').toLowerCase();
        if (key.includes('colour') || key.includes('颜色') || key.includes('外观')) return 'look';
        if (key.includes('timber') || key.includes('木质')) return 'materialFeel';
        if (key.includes('pattern') || key.includes('花纹')) return 'pattern';
        if (key.includes('price') || key.includes('价格')) return 'price';
        if (key.includes('brand') || key.includes('品牌')) return 'brand';
        if (key.includes('board') || key.includes('尺寸')) return 'boardSize';
        if (key.includes('overall') || key.includes('整体')) return 'overallStyle';
        return 'unsure';
      };
      const attribute = mapAttribute(choice);
      saveState({
        rufusV2: {
          ...currentV2,
          task: {
            ...currentV2.task,
            type: 'find_similar',
            matchAttributes: attribute === 'unsure' ? [] : [attribute],
            updatedAt: new Date().toISOString()
          },
          feedback: {
            ...currentV2.feedback,
            reaction: 'reference_similarity_attribute',
            freeText: choice
          }
        }
      });
      conversation.dataset.rfAction = 'reference_similarity_keep';
      conversationBody.textContent = language === 'zh'
        ? '明白。原来的产品还要继续保留在考虑范围里吗？'
        : 'Got it. Do you want to keep the original product in consideration as well?';
      setConversationChoices(language === 'zh'
        ? ['是，保留一起比较', '不用，用更合适的替代', '还不确定']
        : ['Yes, keep it in the comparison', 'No, replace it with better matches', 'Not sure']);
      return;
    }

    if (action === 'reference_similarity_keep') {
      const state = loadState();
      const currentV2 = buildRufusV2State(state);
      const lower = choice.toLowerCase();
      const keepOriginal = lower.startsWith('yes') || choice.includes('保留一起比较')
        ? true
        : (lower.startsWith('no') || choice.includes('不用') ? false : null);
      saveState({
        rufusV2: {
          ...currentV2,
          task: {
            ...currentV2.task,
            type: 'find_similar',
            keepOriginal,
            updatedAt: new Date().toISOString()
          },
          feedback: {
            ...currentV2.feedback,
            reaction: 'reference_similar_request',
            freeText: choice
          }
        },
        recommendationPresentation: { method: 'jev_backend_v1', products: [] },
        recommendationResult: null,
        candidateRanking: { method: 'deterministic_v1', shortlist: [], evaluatedCount: 0, eligibleCount: 0 }
      });
      runtimeCandidatePool = { source: 'conversation_global', products: [] };
      expandedCandidatePoolLoaded = false;
      conversationBody.textContent = language === 'zh'
        ? '好的。我会保留你之前明确的需求，只把这个产品当作参考，然后重新找更合适的选择。'
        : 'Got it. I will keep your previously stated requirements, use this product only as a reference, and look for better-matching alternatives.';
      setConversationChoices([]);
      recommendations.hidden = true;
      recommendationActions.hidden = true;
      loadExpandedCandidatePool().then(() => {
        refreshRecommendationInput({ rank: false });
        refreshHandoffPayload('recommendations_updated');
      });
      return;
    }

    if (action === 'v2_question' || action === 'v2_feedback') return;

    saveState({
      conversationAction: action,
      conversationChoice: choice
    });
    refreshNeedProfile();
    refreshRecommendationInput();

    if (action === 'high_intent_support') {
      const choiceKey = choice.toLowerCase();
      if (choiceKey.includes('quote') || choice.includes('报价') || choiceKey.includes('ask about') || choice.includes('产品')) {
        conversationBody.textContent = language === 'zh' ? '好的，我已经为你打开 enquiry，可以把产品和项目资料一起发给我们。' : 'Done — I am opening the enquiry form with a recommended product selected.';
        openRecommendedEnquiry();
      } else if (choiceKey.includes('compare') || choice.includes('比较')) {
        conversationBody.textContent = language === 'zh' ? '好的，我已经选出两个推荐产品并打开比较。' : 'Done — I am opening a comparison with two recommended options.';
        openRecommendedCompare();
      } else if (choiceKey.includes('keep browsing') || choice.includes('继续浏览')) {
        conversation.hidden = true;
      }
    }

    refreshHandoffPayload('recommendations_updated');
    const latestState = loadState();
    document.dispatchEvent(new CustomEvent('rf:assistant:conversation-input', {
      detail: { source: 'choice', customerState: latestState }
    }));
  });

  conversationSend?.addEventListener('click', async () => {
    const message = conversationText.value.trim();
    const selectedChoice = conversationChoices.querySelector('[data-rf-conversation-choice][aria-pressed="true"]')?.dataset.rfConversationChoice || '';
    const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    const currentAction = conversation.dataset.rfAction || '';

    if (message) {
      // Only explicit statements from the customer may update persistent Need State.
      // Browsing, comparison selections and previously shown products never do this.
      mergeExplicitNeedStatement(message);
      const detectedArea = detectServiceArea(message);
      if (detectedArea.status !== 'unknown') {
        saveState({
          serviceArea: {
            ...detectedArea,
            serviceRegions: serviceAreaRegions,
            updatedAt: new Date().toISOString()
          }
        });
      }
      if (currentAction !== 'reference_confirm' && !currentAction.startsWith('summary_change_') && await maybePrepareExplicitReference(message)) {
        conversationText.value = '';
        return;
      }
    }

    if (currentAction === 'summary_change_budget') {
      if (!selectedChoice && !message) {
        conversationText.focus();
        return;
      }
      const state = loadState();
      const currentV2 = buildRufusV2State(state);
      const explicit = state.needProfile?.explicit || {};
      const budgetUnsure = selectedChoice.toLowerCase().includes('not sure') || selectedChoice.includes('不确定');
      const budgetValue = budgetUnsure ? (language === 'zh' ? '还不确定' : 'Not sure') : (selectedChoice || message);
      const needProfile = {
        explicit: {
          ...explicit,
          priorities: {
            ...(explicit.priorities || {}),
            budget: budgetValue || (explicit.priorities || {}).budget || ''
          }
        },
        updatedAt: new Date().toISOString()
      };
      saveState({
        needProfile,
        rufusV2: {
          ...currentV2,
          need: {
            ...currentV2.need,
            budgetPreference: budgetValue || currentV2.need.budgetPreference
          },
          requirementStatus: {
            ...(currentV2.requirementStatus || {}),
            budget: budgetUnsure ? 'tentative' : 'confirmed'
          },
          feedback: {
            ...currentV2.feedback,
            reaction: 'budget_changed',
            freeText: [selectedChoice, message].filter(Boolean).join(' ')
          }
        }
      });
      refreshRecommendationInput();
      renderAnswerSummary();
      conversationBody.textContent = language === 'zh' ? '好的，预算方向已更新，其他需求保持不变。' : 'Done — I updated the budget direction and kept your other requirements unchanged.';
      setConversationChoices([]);
      conversationText.value = '';
      refreshHandoffPayload('recommendations_updated');
      return;
    }

    if (currentAction === 'summary_change_notes') {
      if (!message) {
        conversationText.focus();
        return;
      }
      const state = loadState();
      const currentV2 = buildRufusV2State(state);
      const explicit = state.needProfile?.explicit || {};
      const needProfile = {
        explicit: {
          ...explicit,
          freeText: message
        },
        updatedAt: new Date().toISOString()
      };
      saveState({
        needProfile,
        freeText: message,
        rufusV2: {
          ...currentV2,
          need: {
            ...currentV2.need,
            freeText: message
          },
          feedback: {
            ...currentV2.feedback,
            reaction: 'notes_changed',
            freeText: message
          }
        }
      });
      refreshRecommendationInput();
      renderAnswerSummary();
      conversationBody.textContent = language === 'zh' ? '好的，说明已更新，其他需求保持不变。' : 'Done — I updated your notes and kept your other requirements unchanged.';
      setConversationChoices([]);
      conversationText.value = '';
      refreshHandoffPayload('recommendations_updated');
      return;
    }

    if (currentAction === 'return_resume' && !message) {
      conversationBody.textContent = language === 'zh'
        ? '好的，我正在重新检查你之前明确告诉我的需求…'
        : 'Okay — I am re-checking the requirements you explicitly told me before…';
      conversationSend.disabled = true;
      refreshNeedProfile(false);
      refreshRecommendationInput({ rank: false });
      refreshHandoffPayload('return_visit');
      window.setTimeout(() => {
        if (conversation.dataset.rfAction === 'return_resume') {
          conversationSend.disabled = false;
        }
      }, 2500);
      return;
    }

    if (currentAction === 'v2_question' || currentAction === 'v2_feedback') {
      if (!selectedChoice && !message) {
        conversationText.focus();
        return;
      }

      const currentState = loadState();
      const currentV2 = buildRufusV2State(currentState);
      const selectedKey = selectedChoice.toLowerCase();
      const freeKey = message.toLowerCase();
      const nextPatch = {};
      let nextV2 = currentV2;
      let requirementKindToRemove = '';

      if (currentAction === 'v2_question') {
        const questionKey = conversation.dataset.rfQuestionKey || '';
        const isNotSure = selectedKey.includes('not sure') || selectedChoice.includes('不确定');
        if (questionKey === 'water_protection') {
          const waterValue = isNotSure
            ? (language === 'zh' ? '还不确定' : 'Not sure')
            : (selectedChoice || message);
          nextV2 = {
            ...currentV2,
            need: { ...currentV2.need, waterProtection: waterValue },
            requirementStatus: {
              ...(currentV2.requirementStatus || {}),
              waterProtection: isNotSure ? 'tentative' : 'confirmed'
            }
          };
          nextPatch.rufusV2 = nextV2;
        }
        if (questionKey === 'pets_traffic') {
          const petsTrafficValue = isNotSure
            ? (language === 'zh' ? '还不确定' : 'Not sure')
            : (selectedChoice || message);
          nextV2 = {
            ...currentV2,
            need: {
              ...currentV2.need,
              pets: /pets|宠物|both|两者/i.test(petsTrafficValue) ? petsTrafficValue : currentV2.need.pets,
              traffic: /traffic|使用强度|both|两者/i.test(petsTrafficValue) ? petsTrafficValue : currentV2.need.traffic
            },
            requirementStatus: {
              ...(currentV2.requirementStatus || {}),
              petsTraffic: isNotSure ? 'tentative' : 'confirmed'
            }
          };
          nextPatch.rufusV2 = nextV2;
        }
        if (questionKey === 'room' && selectedChoice && !isNotSure) {
          nextPatch.room = selectedChoice;
        }
        if (questionKey === 'priority' && selectedChoice) {
          nextPatch.conversationAction = 'offer_help';
          nextPatch.conversationChoice = selectedChoice;
          nextV2 = {
            ...currentV2,
            feedback: {
              reaction: 'priority_changed',
              freeText: message,
              wantsCheaper: false,
              wantsBetterBrand: false,
              wantsMoreOptions: false,
              wantsDifferentStyle: false,
              wantsCompare: false
            }
          };
          nextPatch.rufusV2 = nextV2;
        }
        if (questionKey === 'reference_conflict') {
          const referenceTitle = currentState.explicitReference?.title || currentV2.task.referenceTitle || '';
          const keepRequirement = selectedKey.includes('keep my original requirement') || selectedKey.includes('keep my requirement') || selectedChoice.includes('保留原来的需求') || selectedChoice.includes('保留我的需求');
          const keepException = selectedKey.includes('as an exception') || selectedKey === 'keep this product' || selectedChoice.includes('作为例外') || selectedChoice === '保留这个产品';
          const likeLook = selectedKey.includes('like its look') || selectedChoice.includes('喜欢它的外观');
          const likePrice = selectedKey.includes('like its price') || selectedChoice.includes('喜欢它的价格');
          const changeRequirement = selectedKey.includes('change my original requirement') || selectedChoice.includes('改变原来的需求');
          if (changeRequirement) {
            const conflictText = String(currentState.recommendationResult?.question?.text || '').toLowerCase();
            requirementKindToRemove = conflictText.includes('waterproof') || conflictText.includes('防水') ? 'waterproof'
              : (conflictText.includes('timber') || conflictText.includes('hardwood') || conflictText.includes('天然木') || conflictText.includes('实木') ? 'timber' : '');
          }
          const useGlobalScope = keepRequirement || likeLook || likePrice;
          if (useGlobalScope) clearExplicitReference();
          nextV2 = {
            ...currentV2,
            preferences: {
              ...currentV2.preferences,
              look: likeLook ? referenceTitle : currentV2.preferences.look,
              priceDirection: likePrice ? `similar_to:${referenceTitle}` : currentV2.preferences.priceDirection
            },
            exceptions: keepException && referenceTitle
              ? [...currentV2.exceptions.filter((item) => item.productTitle !== referenceTitle), {
                  productTitle: referenceTitle,
                  conflict: 'explicit_requirement_conflict',
                  decision: 'allow_for_this_product_only'
                }]
              : currentV2.exceptions,
            task: {
              ...currentV2.task,
              type: likeLook || likePrice ? 'find_similar' : (changeRequirement ? 'review_requirements' : currentV2.task.type),
              referenceTitle,
              matchAttributes: likeLook ? ['look'] : (likePrice ? ['price'] : currentV2.task.matchAttributes),
              updatedAt: new Date().toISOString()
            },
            feedback: {
              ...currentV2.feedback,
              reaction: keepRequirement ? 'reference_requirement'
                : keepException ? 'reference_exception'
                : likeLook || likePrice ? 'reference_attribute'
                : changeRequirement ? 'reference_change_requirement'
                : 'reference_unsure',
              freeText: [selectedChoice, message].filter(Boolean).join(' ')
            }
          };
          nextPatch.rufusV2 = nextV2;
        }
        if (questionKey === 'brand_preference') {
          const brandValue = selectedChoice && !isNotSure ? selectedChoice : '';
          nextPatch.conversationFreeText = [brandValue, message].filter(Boolean).join(' ');
          nextV2 = {
            ...currentV2,
            need: {
              ...currentV2.need,
              brandPreference: brandValue || currentV2.need.brandPreference
            },
            feedback: {
              reaction: 'brand_selected',
              freeText: [brandValue, message].filter(Boolean).join(' '),
              wantsCheaper: false,
              wantsBetterBrand: Boolean(brandValue),
              wantsMoreOptions: false,
              wantsDifferentStyle: false,
              wantsCompare: false
            }
          };
          nextPatch.rufusV2 = nextV2;
        }
        if (questionKey === 'style_preference') {
          const styleValue = selectedChoice && !isNotSure ? selectedChoice : '';
          nextPatch.conversationFreeText = [styleValue, message].filter(Boolean).join(' ');
          nextV2 = {
            ...currentV2,
            need: {
              ...currentV2.need,
              style: styleValue ? [styleValue] : currentV2.need.style
            },
            feedback: {
              reaction: 'style_selected',
              freeText: [styleValue, message].filter(Boolean).join(' '),
              wantsCheaper: false,
              wantsBetterBrand: false,
              wantsMoreOptions: false,
              wantsDifferentStyle: Boolean(styleValue || message),
              wantsCompare: false
            }
          };
          nextPatch.rufusV2 = nextV2;
        }
      } else {
        const wantsCheaper = selectedKey.includes('cheaper') || selectedChoice.includes('便宜') || freeKey.includes('cheaper') || freeKey.includes('too expensive');
        const wantsBetterBrand = selectedKey.includes('brand') || selectedChoice.includes('品牌') || freeKey.includes('better brand');
        const wantsMoreOptions = selectedKey.includes('show me more') || selectedChoice.includes('再看') || freeKey.includes('more options');
        const wantsDifferentStyle = selectedKey.includes('different style') || selectedChoice.includes('换一种风格') || freeKey.includes('different style');
        const wantsCompare = selectedKey.includes('compare') || selectedChoice.includes('比较') || freeKey.includes('compare');
        const changedMind = selectedKey.includes('changed my mind') || selectedChoice.includes('改变主意') || freeKey.includes('changed my mind');
        const looksGood = selectedKey.includes('looks good') || selectedChoice.includes('看起来不错');
        const unsure = selectedKey.includes('not sure') || selectedChoice.includes('不确定');

        const reaction = wantsCheaper ? 'want_cheaper'
          : wantsBetterBrand ? 'want_better_brand'
          : wantsMoreOptions ? 'want_more_options'
          : wantsDifferentStyle ? 'want_different_style'
          : wantsCompare ? 'want_compare'
          : changedMind ? 'changed_mind'
          : looksGood ? 'satisfied'
          : unsure ? 'not_sure'
          : 'free_text';

        nextV2 = {
          ...currentV2,
          need: {
            ...currentV2.need,
            budgetPreference: wantsCheaper ? 'lower' : currentV2.need.budgetPreference
          },
          preferences: {
            ...currentV2.preferences,
            priceDirection: wantsCheaper ? 'lower' : currentV2.preferences.priceDirection
          },
          task: {
            ...currentV2.task,
            type: wantsCompare ? 'compare_recommendations'
              : wantsMoreOptions ? 'show_more_options'
              : wantsDifferentStyle ? 'refine_style'
              : wantsBetterBrand ? 'refine_brand'
              : changedMind ? 'review_requirements'
              : currentV2.task.type,
            updatedAt: new Date().toISOString()
          },
          feedback: {
            ...currentV2.feedback,
            reaction,
            freeText: message,
            confirmedDirection: looksGood ? true : (changedMind ? false : currentV2.feedback.confirmedDirection),
            confirmedAt: looksGood ? new Date().toISOString() : currentV2.feedback.confirmedAt,
            wantsCheaper,
            wantsBetterBrand,
            wantsMoreOptions,
            wantsDifferentStyle,
            wantsCompare
          }
        };
        nextPatch.rufusV2 = nextV2;
        if (wantsCheaper) {
          nextPatch.conversationAction = 'budget_help';
          nextPatch.conversationChoice = language === 'zh' ? '预算低一些' : 'Lower budget';
        }
      }

      saveState(nextPatch);
      if (requirementKindToRemove) removeRequirementFromNeedState(requirementKindToRemove);
      refreshNeedProfile();
      renderAnswerSummary();
      refreshRecommendationInput();
      conversationBody.textContent = language === 'zh' ? '好的，我正在根据你的反馈重新筛选…' : 'Got it — I am refining the options from your feedback…';
      conversationSend.disabled = true;
      refreshHandoffPayload('recommendations_updated');
      return;
    }

    if (!message) {
      conversationText.focus();
      return;
    }

    const lowerMessage = message.toLowerCase();
    let action = currentAction;

    if (lowerMessage.includes('spc') || lowerMessage.includes('hybrid')) action = 'type_help';
    else if (lowerMessage.includes('timber') || lowerMessage.includes('hardwood') || lowerMessage.includes('wood')) action = 'type_help';
    else if (lowerMessage.includes('budget') || lowerMessage.includes('cheap') || lowerMessage.includes('value')) action = 'budget_help';

    saveState({
      conversationAction: action,
      conversationChoice: selectedChoice,
      conversationFreeText: message
    });
    refreshNeedProfile();
    refreshRecommendationInput();

    conversationBody.textContent = language === 'zh'
      ? '收到。我已经把你的这句话加入筛选条件，并更新下面的推荐。'
      : 'Got it. I have used that note to update the recommendations below.';
    conversationText.value = '';

    window.setTimeout(() => {
      renderRecommendationCards();
      refreshHandoffPayload('recommendations_updated');
    }, 0);

    const latestState = loadState();
    document.dispatchEvent(new CustomEvent('rf:assistant:conversation-input', {
      detail: { source: 'free_text', customerState: latestState }
    }));
  });

  const showAvailableOptionsNow = () => {
    const stage1State = loadState().enq10qaStage1;
    if (stage1State?.completedAt && stage1State?.phase === 'type_guide') {
      renderStage1Result(stage1State);
      return;
    }
    const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    ensureDecisionAssumptions();
    refreshNeedProfile(false);
    refreshRecommendationInput();
    renderAnswerSummary();
    renderRecommendationCards();

    const products = loadState().recommendationPresentation?.products || [];
    if (!products.length && recommendations) {
      recommendations.hidden = false;
      recommendations.replaceChildren();
      const box = document.createElement('div');
      box.className = 'rf-jev__browse-fallback';
      const intro = document.createElement('p');
      intro.textContent = language === 'zh'
        ? '根据目前的信息，我先给你可以浏览的方向。补充更多需求后，我会再缩小到具体产品。'
        : 'Based on what I know so far, here are useful places to start. Add more details and I can narrow this to specific products.';
      const hub = document.createElement('a');
      hub.href = '/collections/floorboards';
      hub.textContent = language === 'zh' ? '浏览所有地板类型' : 'Browse suitable flooring types';
      box.append(intro, hub);
      recommendations.append(box);
    }

    conversationBody.textContent = language === 'zh'
      ? '我先按现有信息给你建议；未确认或 Rufus 暂定的内容不会当作硬性条件。'
      : 'I will show the best options I can from the information so far. Unconfirmed answers are not treated as hard requirements.';
    conversationMain.hidden = false;
    questionStep.hidden = true;
    languageStep.hidden = true;
    conversation.hidden = false;
    launcher.hidden = true;
  };

  const startOverRufus = () => {
    const language = localStorage.getItem(languageKey) === 'zh' ? 'zh' : 'en';
    const ok = window.confirm(language === 'zh'
      ? '重新开始 Rufus 对话？这会清除本次地板需求和回答，但不会删除你的客户/询价资料。'
      : 'Start a new Rufus conversation? This clears the current flooring requirements and answers, but does not delete any customer or enquiry record.');
    if (!ok) return;

    localStorage.removeItem(stateKey);
    stage1Draft = createEmptyStage1Draft();
    stage1Step = 0;
    conversationText.hidden = false;
    conversationSend.hidden = false;
    runtimeCandidatePool = { source: 'conversation_global', products: [] };
    expandedCandidatePoolLoaded = false;
    pendingExplicitReference = null;
    runtimeReferenceGuideProduct = null;
    freeText.value = '';
    conversationText.value = '';
    recommendations.replaceChildren();
    recommendations.hidden = true;
    recommendationActions.hidden = true;
    openOnboarding();
  };

  root.querySelectorAll('[data-rf-start-over]').forEach((button) => {
    button.addEventListener('click', startOverRufus);
  });
  root.querySelectorAll('[data-rf-show-options]').forEach((button) => {
    button.addEventListener('click', showAvailableOptionsNow);
  });

  const openRufus = () => {
    const state = loadState();
    const stage1State = state.enq10qaStage1;
    if (stage1State?.version === 1 && stage1State?.completedAt) {
      renderStage1Result(stage1State);
      return;
    }

    stage1Draft = state.enq10qaDraft && typeof state.enq10qaDraft === 'object'
      ? { ...createEmptyStage1Draft(), ...state.enq10qaDraft }
      : createEmptyStage1Draft();
    stage1Step = 0;
    conversationText.hidden = false;
    conversationSend.hidden = false;
    openOnboarding();
  };

  launcher?.addEventListener('click', openRufus);

  document.querySelectorAll('[data-rf-rufus-header-open]').forEach((button) => {
    button.addEventListener('click', openRufus);
  });

  conversationClose?.addEventListener('click', () => {
    conversation.hidden = true;
    launcher.hidden = false;
    launcher.focus();
  });

  continueButton.addEventListener('click', () => {
    const selectedRooms = Array.from(root.querySelectorAll('[data-rf-room][aria-pressed="true"]'))
      .map((button) => button.dataset.rfRoom || '')
      .filter(Boolean);
    const selectedRoom = selectedRooms.join(', ');
    const answerText = freeText.value.trim();
    const language = localStorage.getItem(languageKey) || 'en';

    if (!selectedRooms.length && !answerText) {
      freeText.focus();
      return;
    }

    continueButton.disabled = true;
    continueButton.textContent = language === 'zh' ? '正在处理…' : 'Working…';

    const roomUnsure = selectedRooms.some((room) => room === 'Not sure' || room === '还不确定');
    const beforeContinue = buildRufusV2State(loadState());
    saveState({
      language,
      room: selectedRoom,
      rooms: selectedRooms,
      freeText: answerText,
      rufusV2: {
        ...beforeContinue,
        requirementStatus: {
          ...(beforeContinue.requirementStatus || {}),
          room: roomUnsure ? 'tentative' : 'confirmed'
        }
      }
    });
    ensureDecisionAssumptions();

    // Move the UI forward immediately after the customer's explicit answer.
    // State sync / backend preparation must never be able to block the Continue button.
    let latestState = loadState();
    const observationDecision = latestState.observation?.decision?.action || '';
    const nextAction = observationEnabled && observationDecision && observationDecision !== 'stay_silent'
      ? observationDecision
      : 'offer_help';

    openConversation(nextAction);
    continueButton.textContent = language === 'zh' ? '已继续 ✓' : 'Continued ✓';

    try {
      refreshNeedProfile();
      renderAnswerSummary();
      refreshRecommendationInput();
      refreshHandoffPayload('first_answer');
      latestState = loadState();
    } catch (error) {
      console.warn('[Rufus] Continue state sync failed; conversation remains usable.', error);
    }

    root.dispatchEvent(new CustomEvent('rf:assistant:first-answer', {
      bubbles: true,
      detail: {
        visitorId,
        isReturningVisitor,
        language,
        room: selectedRoom,
        freeText: answerText,
        customerState: latestState
      }
    }));

    window.setTimeout(() => {
      continueButton.disabled = false;
      continueButton.textContent = copy[language]?.continue || copy.en.continue;
    }, 900);
  });

  root.hidden = false;
  launcher.hidden = false;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-promo-hybrid-v1-gallery-b"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rf-v1-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-rf-v1-track]');
    const prev = slider.querySelector('[data-rf-v1-prev]');
    const next = slider.querySelector('[data-rf-v1-next]');

    if (!track || !prev || !next) return;

    const getStep = () => {
      const firstCard = track.querySelector('.rf-v1-gallery-b__thumb');
      if (!firstCard) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-promo-hybrid-v1-product-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rf-v1-product-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-rf-v1-product-track]');
    const prev = slider.querySelector('[data-rf-v1-product-prev]');
    const next = slider.querySelector('[data-rf-v1-product-next]');

    if (!track || !prev || !next) return;

    const getStep = () => {
      const firstCard = track.querySelector('.rf-v1-product-slider__item');
      if (!firstCard) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });

  } catch(e) { console.error(e); }
})();
})();
